(function() {
  'use strict';

  angular
    .module('office', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource',
      'ui.router', 'ui.bootstrap', 'toastr', 'ui.grid','ui.grid.pagination', 'ui.grid.selection', 'ngFileUpload']).
    controller('INDEXController', ['UserService',"$scope", function(UserService, $scope) {
      $scope.limitedUser = UserService.userdata.limitedUser;


    }]
  )

})();

                                                              (function () {
  'use strict';
  /*

     This is new way of using generic modal window. This is accompanied with gendialog component. use ui.bootstrap
     method $uibModal.open to create modal window which content is coming from gen-dialog component. The parameters
     are:
     agree : requires function as parameter - this is bind to agree-button aka actionbuttontext
     dismiss: requires function as paramenter - this is bind to cancel-button
     headingtext: requires string and this is the title of dialog window
     explanation: This informative information for dialog reader. it is string placed in <p></p>
     okvisible: Boolean. if true, then button is visible
     cancelvisible: Boolean. if true, then button is visible
     actionbuttontext: String. text shown in agree button
     cancelbuttontext: String. Text shown in cancel button

    Use this modal window with placing this function where gendialog is needed.
          vm.opendialog = function () {
          $uibModal.open({
            template: '<gen-dialog agree="$ctrl.agree()" dismiss="$dismiss()" headingtext="Poista tiedosto" explanation="{{$ctrl.explanation}}" okvisible="true", actionbuttontext="Poista", cancelvisible="false", closebuttontext="Peruuta"  ></gen-dialog>',
            controller: function () {
              var cp = this;
              cp.explanation = "Haluatko todella poistaa tiedoston? Et voi peruuttaa poistamista";
              cp.agree = function () {
                alert("poistan");
              }
            },
            controllerAs: '$ctrl',
            windowClass: 'app-gen-dialog'
          });
        };
   */

  angular
    .module('office')
    .component('genDialog', {
      templateUrl: 'app/components/gendialog/gendialog.html',
      controllerAs: 'main',
      bindings: {
        headingtext: '@',
        explanation: '@',
        close: '&',
        dismiss: '&',
        agree: '&',
        okvisible: '=',
        actionbuttontext: '@',
        closebuttontext: '@',
        cancelvisible: "="
      },
      controller: function () {

      }


    });
})();


(function () {
  'use strict';

  angular
    .module('office')
    .component('permitListTable', {
      templateUrl: "app/components/permitlist/permitlistable.html",
      controller: ['$scope', '$log', '$http', 'uiGridConstants', '$templateCache', '$state', function ($scope, $log, $http, uiGridConstants, $templateCache, $state) {
        var paginationOptions = {
          pageNumber: 1,
          pageSize: 25

        };

        $scope.showDatePopup = [];
        $scope.showDatePopup.push({opened: false});
        $scope.showDatePopup.push({opened: false});
        $templateCache.put('ui-grid/date-cell',
          "<div class='ui-grid-cell-contents'>{{COL_FIELD | date:'dd.MM.yyyy HH:MM:ss'}}</div>");
        /* This is template for date range for permit_end*/
        $templateCache.put('ui-grid/ui-grid-date-filter',
          "<div class=\"ui-grid-filter-container\" ng-repeat=\"colFilter in col.filters\" >" +
          "<input type=\"text\" uib-datepicker-popup=\"{{datePicker.format}}\" " +
          "starting-day=\"3\"" + " ng-model-options=\"{timezone: 'UTC'}\"" +
          "datepicker-append-to-body=\"true\" show-button-bar=\"true\" date-format = \"dd.yyyy.MM\" show-weeks = \"false\" current-text = \"{{$parent.$ctrl.include_expired}}\" clear-text = \"Tyhjennä\"close-text = \"Sulje\"" +
          "is-open=\"showDatePopup[$index].opened\" class=\"ui-grid-filter-input ui-grid-filter-input-{{$index}}\"" +
          "style=\"font-size:1em; width:11em!important\" ng-model=\"colFilter.term\" ng-attr-placeholder=\"{{colFilter.placeholder || ''}}\" " +
          " aria-label=\"{{colFilter.ariaLabel || aria.defaultFilterLabel}}\" />" +

          "<span style=\"padding-left:0.3em;\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"showDatePopup[$index].opened = true\">" +
          "<i class=\"glyphicon glyphicon-calendar\"></i></button></span>" +

          "<div role=\"button\" class=\"ui-grid-filter-button\" ng-click=\"removeFilter(colFilter, $index)\" ng-if=\"!colFilter.disableCancelFilterButton\" ng-disabled=\"colFilter.term === undefined || colFilter.term === null || colFilter.term === ''\" ng-show=\"colFilter.term !== undefined && colFilter.term !== null && colFilter.term !== ''\">" +
          "<i class=\"ui-grid-icon-cancel\" ui-grid-one-bind-aria-label=\"aria.removeFilter\">&nbsp;</i></div></div><div ng-if=\"colFilter.type === 'select'\"><select class=\"ui-grid-filter-select ui-grid-filter-input-{{$index}}\" ng-model=\"colFilter.term\" ng-attr-placeholder=\"{{colFilter.placeholder || aria.defaultFilterLabel}}\" aria-label=\"{{colFilter.ariaLabel || ''}}\" ng-options=\"option.value as option.label for option in colFilter.selectOptions\"><option value=\"\"></option></select><div role=\"button\" class=\"ui-grid-filter-button-select\" ng-click=\"removeFilter(colFilter, $index)\" ng-if=\"!colFilter.disableCancelFilterButton\" ng-disabled=\"colFilter.term === undefined || colFilter.term === null || colFilter.term === ''\" ng-show=\"colFilter.term !== undefined && colFilter.term != null\"><i class=\"ui-grid-icon-cancel\" ui-grid-one-bind-aria-label=\"aria.removeFilter\">&nbsp;</i></div></div>"
        );
        var ctrl = this;
        ctrl.include_expired = false; // by default we want only those permits that are still valid
        ctrl.myData2 = [];
        $scope.datePicker = {
          options: {
            startingDay: 1,
            showWeeks: false
          },
          format: "DD.MM.YYYY"
        };

        ctrl.gettableData = function () {
          var offset = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
          var params = {
            "limit": paginationOptions.pageSize,
            "offset": offset
          };
          var paramsToBackEnd = angular.copy(paginationOptions)
          if (paramsToBackEnd.hasOwnProperty("filteroptions")) {
            var filteroptions = angular.copy(paramsToBackEnd.filteroptions)
            // this looks idiotic, but does its job to convert date to python date
            if (filteroptions.hasOwnProperty('permit_start_after') && angular.isDefined(filteroptions['permit_start_after'])) {
              try {
                filteroptions['permit_start_after'] = filteroptions['permit_start_after'].toISOString().split("T")[0]
              } catch (err) {
                filteroptions['permit_start_after'] = null;
              }
            }
            if (filteroptions.hasOwnProperty('permit_start_before') && angular.isDefined(filteroptions['permit_start_before'])) {
              try {
                filteroptions['permit_start_before'] = filteroptions['permit_start_before'].toISOString().split("T")[0]
              } catch (err) {
                filteroptions['permit_start_before'] = null;
              }

            }
            if (filteroptions.hasOwnProperty('permit_end_after') && angular.isDefined(filteroptions['permit_end_after'])) {
              try {
                filteroptions['permit_end_after'] = filteroptions['permit_end_after'].toISOString().split("T")[0]
              } catch (err) {
                filteroptions['permit_end_after'] = null;
              }

            }
            if (filteroptions.hasOwnProperty('permit_end_before') && angular.isDefined(filteroptions['permit_end_before'])) {
              try {
                filteroptions['permit_end_before'] = filteroptions['permit_end_before'].toISOString().split("T")[0]
              } catch (err) {
                filteroptions['permit_end_before'] = null;
              }

            }
            paramsToBackEnd.filteroptions = filteroptions;
          }

          angular.extend(params, paramsToBackEnd.filteroptions);


          for (var i in paginationOptions.filteroptions) {
            if (paginationOptions.filteroptions[i] && paginationOptions.filteroptions[i].length > 0)
              params[i] = paginationOptions.filteroptions[i]

          }
          if (!ctrl.gridApi)
            params['permit_end_after'] = new Date();
          if (paginationOptions.sortcolumn && paginationOptions.sort) {
            if (paginationOptions.sort === "asc") {
              params['ordering'] = ""
            } else {
              params['ordering'] = "-"
            }

            params['ordering'] += paginationOptions.sortcolumn;


          } else {
            params['ordering'] = "customer";
          }

          $http.get("/permits/permitlist",
            {
              params: params
            }
          ).then(function (data) {
            $log.debug(data);

            ctrl.gridOptions.data = data['data']['results'];
            ctrl.gridOptions.totalItems = data['data']['count'];
          }, function (data) {
            $log.debug(data);
          })
        };

        ctrl.expiredChanged = function () {
          if (ctrl.include_expired) {
            if (ctrl.gridApi.grid.columns[5].filters[0]) {
              ctrl.gridApi.grid.columns[5].filters[0].term = "";
            }
          } else if (ctrl.include_expired==false) {
            ctrl.gridApi.grid.columns[5].filters[0].term = new Date();
          }
          //ctrl.gettableData();
        };

        ctrl.gridOptions = {
          enableFullRowSelection: true,
          modifierKeysToMultiSelect: false,
          enableRowHeaderSelection: false,
          enableRowSelection: true,
          multiSelect: false,
          paginationPageSizes: [25, 50, 75],
          paginationPageSize: paginationOptions.pageSize,
          useExternalPagination: true,
          useExternalSorting: true,
          useExternalFiltering: true,
          enableFiltering: true,

          showPaginationControls: true,

          columnDefs: [
            {
              field: 'contract_number',
              displayName: 'sop.numero',
              width: '6%',
              sort: {direction: uiGridConstants.DESC, priority: 0}
            },
            {field: 'regid', displayName: 'rek.tunnus', width: '10%'},
            {field: 'parking_area', displayName: 'Alue', width: '15%'},
            {field: 'permit_type', displayName: 'Lupatyyppi', width: '15%'},
            {
              field: 'permit_start',
              displayName: 'alk.aika',
              width: '20%',
              cellFilter: 'date:"dd.MM.yyyy"',
              filterHeaderTemplate: 'ui-grid/ui-grid-date-filter',
              filters: [
                {
                  // eslint-disable-next-line no-unused-vars
                  condition: function (term, value, row, column) {
                    column = column
                    /*if (!term) return true;
                     var valueDate = new Date(value);
                     return valueDate >= term;*/
                  },
                  placeholder: 'päivästä'
                },
                {
                  // eslint-disable-next-line no-unused-vars
                  condition: function (term, value, row, column) {
                    column = column
                    /* if (!term) return true;
                     var valueDate = new Date(value);
                     return valueDate <= term;*/
                  },
                  placeholder: 'päivään'
                }
              ]
            },

            {
              field: 'permit_end',
              displayName: 'Päät.aika',
              width: '20%',
              cellFilter: 'date:"dd.MM.yyyy"',
              filterHeaderTemplate: 'ui-grid/ui-grid-date-filter',
              filters: [
                {
                  // eslint-disable-next-line no-unused-vars
                  condition: function (term, value, row, column) {
                    column = column
                    /*if (!term) return true;
                     var valueDate = new Date(value);
                     return valueDate >= term;*/
                  },
                  term: new Date(),

                  placeholder: 'päivästä'
                },
                {
                  // eslint-disable-next-line no-unused-vars
                  condition: function (term, value, row, column) {
                    column = column
                    /* if (!term) return true;
                     var valueDate = new Date(value);
                     return valueDate <= term;*/
                  },
                  placeholder: 'päivään'
                }
              ]
            },
            {
              field: 'customer', displayName: 'As. Nimi', width: '12%'
            }

          ],

          onRegisterApi: function (gridApi) {
            ctrl.gridApi = gridApi;
            ctrl.gridApi.core.on.filterChanged(null, function () {
              var grid = gridApi.grid;
              paginationOptions.filteroptions = {};

              for (var f in grid.columns) {
                if (grid.columns[f].filters.length === 1) {
                  paginationOptions.filteroptions[grid.columns[f].name] = grid.columns[f].filters[0].term;
                } else {
                  paginationOptions.filteroptions[grid.columns[f].name + "_after"] = grid.columns[f].filters[0].term;
                  paginationOptions.filteroptions[grid.columns[f].name + "_before"] = grid.columns[f].filters[1].term;

                }
              }

              ctrl.gettableData();

            });
            ctrl.gridApi.core.on.sortChanged(null, function (grid, sortColumns) {
              if (sortColumns.length === 0) {
                paginationOptions.sort = uiGridConstants.DESC
                paginationOptions.sortcolumn = 'contract_number';
              } else {
                paginationOptions.sort = sortColumns[0].sort.direction;
                paginationOptions.sortcolumn = sortColumns[0].name;

              }
              ctrl.gettableData();
            });

            gridApi.selection.on.rowSelectionChanged($scope, function (row) {
              $state.go("permitparking.permiteditor", {permitID: row.entity.id})
            });

            gridApi.pagination.on.paginationChanged(null, function (newPage, pageSize) {
              if (paginationOptions.pageSize !== pageSize) {
                paginationOptions.pageNumber = 1;
              } else {
                paginationOptions.pageSize = pageSize;
                paginationOptions.pageNumber = newPage;
              }
              ctrl.gettableData();
            });
          }
        };
        ctrl.gettableData();
      }
      ]
    });

})
();


(function () {
  'use strict';

  angular
    .module('office')
    .component('permitEditor', {
      bindings: {
        message: '='
    },
      templateUrl : "app/components/permiteditor/permiteditor.html"

    });


})();

(function () {
  'use strict';

  angular
    .module('office')
    .component('paymentTable', {
      templateUrl: "app/components/paidparkings/paidparkingtable.html",
      controller: ['$scope', '$log', '$http', '$templateCache', function ($scope, $log, $http, $templateCache) {
        var paginationOptions = {
          pageNumber: 1,
          pageSize: 25

        };
        $scope.datePicker = {

          options: {
            startingDay: 1,
            format: "dd.MM.yyyy"
          },
          format: "dd.MM.yyyy"
        };

        $scope.showDatePopup = [];
        $scope.showDatePopup.push({opened: false});
        $scope.showDatePopup.push({opened: false});
        $templateCache.put('ui-grid/date-cell',
          "<div class='ui-grid-cell-contents'>{{COL_FIELD | date:'dd.MM.yyyy HH:mm:ss'}}</div>");

        $templateCache.put('ui-grid/ui-grid-date-filter',
          "<div class=\"ui-grid-filter-container\" ng-repeat=\"colFilter in col.filters\" >" +
          "{{datePicker.options}} <input type=\"text\" uib-datepicker-popup=\"{{datePicker.options}}\" " +
          " date-format='MM/dd/yyyy' " + " ng-model-options=\"{timezone: 'UTC'}\"" +
          "datepicker-append-to-body=\"true\" show-button-bar=\"false\"" +
          "is-open=\"showDatePopup[$index].opened\" class=\"ui-grid-filter-input ui-grid-filter-input-{{$index}}\"" +
          "style=\"font-size:1em; width:11em!important\" ng-model=\"colFilter.term\" ng-attr-placeholder=\"{{colFilter.placeholder || ''}}\" " +
          " aria-label=\"{{colFilter.ariaLabel || aria.defaultFilterLabel}}\" />" +

          "<span style=\"padding-left:0.3em;\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"showDatePopup[$index].opened = true\">" +
          "<i class=\"glyphicon glyphicon-calendar\"></i></button></span>" +

          "<div role=\"button\" class=\"ui-grid-filter-button\" ng-click=\"removeFilter(colFilter, $index)\" ng-if=\"!colFilter.disableCancelFilterButton\" ng-disabled=\"colFilter.term === undefined || colFilter.term === null || colFilter.term === ''\" ng-show=\"colFilter.term !== undefined && colFilter.term !== null && colFilter.term !== ''\">" +
          "<i class=\"ui-grid-icon-cancel\" ui-grid-one-bind-aria-label=\"aria.removeFilter\">&nbsp;</i></div></div><div ng-if=\"colFilter.type === 'select'\"><select class=\"ui-grid-filter-select ui-grid-filter-input-{{$index}}\" ng-model=\"colFilter.term\" ng-attr-placeholder=\"{{colFilter.placeholder || aria.defaultFilterLabel}}\" aria-label=\"{{colFilter.ariaLabel || ''}}\" ng-options=\"option.value as option.label for option in colFilter.selectOptions\"><option value=\"\"></option></select><div role=\"button\" class=\"ui-grid-filter-button-select\" ng-click=\"removeFilter(colFilter, $index)\" ng-if=\"!colFilter.disableCancelFilterButton\" ng-disabled=\"colFilter.term === undefined || colFilter.term === null || colFilter.term === ''\" ng-show=\"colFilter.term !== undefined && colFilter.term != null\"><i class=\"ui-grid-icon-cancel\" ui-grid-one-bind-aria-label=\"aria.removeFilter\">&nbsp;</i></div></div>"
        );
        var ctrl = this;
        ctrl.myData2 = [];

        ctrl.gridOptions = {
          rowHeight: 40,
          paginationPageSizes: [25, 50, 75],
          paginationPageSize: paginationOptions.pageSize,
          useExternalPagination: true,
          useExternalSorting: true,
          useExternalFiltering: true,
          enableFiltering: true,

          showPaginationControls: true,

          columnDefs: [
            {field: 'licenseNumber', displayName: 'Rek.tunnus', width: '8%'},
            {field: 'areaNo', displayName: 'Pys.alue', width: '22%',
            cellTemplate: '<span>{{(row.entity.permitName) && (row.entity.permitName+": " + row.entity.areaName +"/") || ("")}} </span><span>{{row.entity.areaNo}}</span>'},
            {field: 'operator', displayName: 'Oper.', width: '8%'},
            {
              field: 'created',
              displayName: 'Kirjattu',
              width: '14%',
              cellFilter: 'date:"dd.MM.yyyy HH:mm:ss"',
              enableFiltering: false
            },
            {
              field: 'startDate',
              displayName: 'Aloitusaika',
              type: "date",
              width: '20%',
              cellFilter: 'date:"dd.MM.yyyy HH:mm:ss"',
              cellTemplate: 'ui-grid/date-cell',
              filterHeaderTemplate: 'ui-grid/ui-grid-date-filter',
              filters: [
                {
                  condition: function (term, value, row, column) {
                    column = column  // stupid isnt? But eslint ignores seems not to work
                    /*if (!term) return true;
                    var valueDate = new Date(value);
                    return valueDate >= term;*/
                  },
                  placeholder: 'päivästä'
                },
                {
                  condition: function (term, value, row, column) {
                    column = column
                   /* if (!term) return true;
                    var valueDate = new Date(value);
                    return valueDate <= term;*/
                  },
                  placeholder: 'päivään'
                }
              ]
            },
            {
              field: 'endDate',
              displayName: 'Päät.aika',
              type: "date",
              width: '20%',
              cellFilter: 'date:"dd.MM.yyyy HH:mm:ss"',
              cellTemplate: 'ui-grid/date-cell',
              filterHeaderTemplate: 'ui-grid/ui-grid-date-filter',
              filters: [
                {
                  condition: function (term, value, row, column) {
                    column = column  // stupid isnt? But eslint ignores seems not to work
                    /*if (!term) return true;
                    var valueDate = new Date(value);
                    return valueDate >= term;*/
                  },
                  placeholder: 'päivästä'
                },
                {
                  condition: function (term, value, row, column) {
                    column = column
                   /* if (!term) return true;
                    var valueDate = new Date(value);
                    return valueDate <= term;*/
                  },
                  placeholder: 'päivään'
                }
              ]
            },
            {field: 'externalParkingId', displayName: 'ID', width: '8%'}
          ],


          onRegisterApi: function (gridApi) {
            ctrl.gridApi = gridApi;
            ctrl.gridApi.core.on.filterChanged(null, function () {
              var grid = gridApi.grid;
              paginationOptions.filteroptions = {};
              for (var f in grid.columns) {
                if (grid.columns[f].filters.length == 1) {
                  paginationOptions.filteroptions[grid.columns[f].name] = grid.columns[f].filters[0].term;
                } else {
                  paginationOptions.filteroptions[grid.columns[f].name + "_after"] = grid.columns[f].filters[0].term;
                  paginationOptions.filteroptions[grid.columns[f].name + "_before"] = grid.columns[f].filters[1].term;
                }
              }
              ctrl.gettableData();

            });
            ctrl.gridApi.core.on.sortChanged(null, function (grid, sortColumns) {
              if (sortColumns.length === 0) {
                paginationOptions.sort = null;
              } else {

                paginationOptions.sort = sortColumns[0].sort.direction;
                paginationOptions.sortcolumn = sortColumns[0].name;

              }
              ctrl.gettableData();
            });
            ctrl.gridApi.pagination.on.paginationChanged(null, function (newPage, pageSize) {
              if (paginationOptions.pageSize != pageSize) {
                paginationOptions.pageNumber = 1;
              } else {
                paginationOptions.pageSize = pageSize;
                paginationOptions.pageNumber = newPage;
              }


              ctrl.gettableData();
            });


          }
        };
        ctrl.gettableData = function () {
          var offset = (ctrl.gridOptions.paginationCurrentPage - 1) * ctrl.gridOptions.paginationPageSize;

          var params = {
            "limit": ctrl.gridOptions.paginationPageSize,
            "offset": offset
          };
          var paramsToBackEnd = angular.copy(paginationOptions)
          if(paramsToBackEnd.hasOwnProperty("filteroptions")){
          var filteroptions = angular.copy(paramsToBackEnd.filteroptions)
          // this looks idiotic, but does its job to convert date to python date
            if(filteroptions.hasOwnProperty('startDate_after') && angular.isDefined(filteroptions['startDate_after'])){
              try{
                filteroptions['startDate_after'] = filteroptions['startDate_after'].toISOString().split("T")[0]
              }  catch(err){
                filteroptions['startDate_after'] = null;
              }

          }
          if(filteroptions.hasOwnProperty('startDate_before') && angular.isDefined(filteroptions['startDate_before'])){
            try{
              filteroptions['startDate_before'] = filteroptions['startDate_before'].toISOString().split("T")[0]
            }catch(err){
              filteroptions['startDate_before'] = null;
            }

          }
          if(filteroptions.hasOwnProperty('endDate_after')&& angular.isDefined(filteroptions['endDate_after'])){
            try{
              filteroptions['endDate_after'] = filteroptions['endDate_after'].toISOString().split("T")[0]
            }catch (err){
              filteroptions['endDate_after'] = null;
            }

          }
          if(filteroptions.hasOwnProperty('endDate_before')&& angular.isDefined(filteroptions['endDate_before'])){
            try{
              filteroptions['endDate_before'] = filteroptions['endDate_before'].toISOString().split("T")[0]
            } catch(err){
              filteroptions['endDate_before'] = null;
            }

          }
          paramsToBackEnd.filteroptions = filteroptions;
          }

          angular.extend(params, paramsToBackEnd.filteroptions);
          if (paginationOptions.sortcolumn && paginationOptions.sort) {
            if (paginationOptions.sort == "asc") {
              params['ordering'] = ""
            } else {
              params['ordering'] = "-"
            }
            params['ordering'] += paginationOptions.sortcolumn;
          }

          $http.get("/paidparking/parking",
            {
              params: params
            }
          ).then(function (data) {
            ctrl.gridOptions.data = data['data']['results'];
            ctrl.gridOptions.totalItems = data['data']['count'];
          }, function (data) {
            $log.debug(data);
          })
        };
        ctrl.gettableData();
      }
      ]
    });


})
();


(function () {
  'use strict';

  angular
    .module('office')
    .directive('acmeNavbar', [function () {
      var directive = {
        restrict: 'E',
        templateUrl: 'app/components/navbar/navbar.html',
        controllerAs: 'nv',
        bindToController: true,
        scope: {
          creationDate: '=',
          limitedUser: '='
        },
        controller: ['$log','$location','$scope','AuthService', 'UserService','AUTH_EVENTS','$rootScope', function ($log, $location,$scope, AuthService, UserService, AUTH_EVENTS,$rootScope) {
                // eslint-disable-next-line no-unused-vars
        $scope.$on(AUTH_EVENTS.loginSuccess, function() {
          AuthService.getuserdata().then(function() {
          var userGroups = UserService.getuserinfo().userRole;
          if(userGroups.includes("property")||userGroups.includes("facilityservices")){
              $scope.limitedUser = true;
              $rootScope.$broadcast(AUTH_EVENTS.userRolesFetched);
          } else {
            $scope.limitedUser = false;
          }
        }, function(err){
          $log.debug(err)
        })
        });

          $scope.isActive = function (viewLocation) {
            return viewLocation === $location.path();
          };

          $scope.logout = function(){
            AuthService.logout();

          }

        }]

      };

      return directive;
    }]);


})();

(function () {
  'use strict';

  angular
    .module('office')
    .directive('loginDialog', ['$state', '$rootScope', 'AUTH_EVENTS', 'AuthService',  function ($state, $rootScope, AUTH_EVENTS, AuthService) {
      return {
        restrict: 'A',
        templateUrl: "app/components/logindialog/login-form.html",

        controller: function ($scope) {
          var showDialog = function () {
            $scope.visible = true;
          };
          $scope.visible = false;
          $scope.$on(AUTH_EVENTS.notAuthenticated, showDialog);

          $scope.$on(AUTH_EVENTS.sessionTimeout, showDialog);

          $scope.login = function (credentials) {
            $scope.message = "";
            AuthService.login(credentials).then(function (user) {
              user = user // due eslint ignores not working
              $rootScope.$broadcast(AUTH_EVENTS.loginSuccess);
              $state.transitionTo('home');
            }, function (res) {
              if (res.status == 400 || res.status == 401 || res.status == 403 || res.status == 404 || res.status == 405) {
                $scope.message = "Tunnus tai salasana on väärin";
              } else if (res.status == -1) {
                $scope.message = "Ei yhteyttä palvelimelle";
              }
              $rootScope.$broadcast(AUTH_EVENTS.loginFailed);

            });
          };
        },
        controllerAs: 'vm',
        bindToController: true
      };
    }]);

})();


(function() {
  'use strict';

  angular
    .module('office')
    .controller('LoginController',['$timeout', function(data) {
        data=data
  }])


})();

(function () {
  'use strict';
  angular
    .module('office')
    .controller('MainController', ['$timeout', '$http', '$log', '$state', '$window','UserService','AUTH_EVENTS','AuthService','$scope',
      function ($timeout, $http, $log, $state, $window, UserService, AUTH_EVENTS, AuthService,$scope) {
        var vm = this;
        vm.limitedUser = UserService.userdata.limitedUser;
        $scope.$on(AUTH_EVENTS.userRolesFetched, function() {
          vm.limitedUser = UserService.userdata.limitedUser;
          }
          );

        vm.twodigits = function (number) {
          var dm = number >= 10 ? number : "0" + number.toString();
          return dm.toString();
        };
        vm.regid = "";
        vm.regresponse = "";
        vm.regdate = new Date();
        vm.regtime = new Date();
        var years = [];
        var thisyear = new Date().getFullYear();
        for (var i = thisyear - 6; i <= thisyear; i++) {
          years.push(i);
        }
        vm.reportyearoptions = years;
        vm.reportyear = thisyear;
        vm.reportmonth = vm.twodigits(new Date().getMonth());

        vm.paidparking_all_report = function () {
          $window.open("/office/fullreport/" + vm.reportyear + "/" + vm.reportmonth);

        };

        vm.getNewPermit = function () {
          $log.debug("entering permiteditor")
          $state.go("permitparking.permiteditor",{permitID: -1});
        };

        vm.get_permit_contractnumber = function(){
          if(!vm.contract_number)return;
          $state.go("permitparking.permiteditor",{contract_number:vm.contract_number, permitID: -1});
        };

        vm.datepickeropts = {
          'year-format': "yy",
          'starting-day': 1
        };
        vm.activepermits = function () {

          $window.open("/office/activepermits");

        };


        vm.paidparking_day_report = function () {
          if (vm.dayreportday === angular.isUndefined()) {
            return;
          }
          $window.open("/office/dayreport/" + vm.dayreportday.getFullYear() + "/" + (vm.dayreportday.getMonth() + 1) + "/" + vm.dayreportday.getDate());

        };
        vm.getParking_info = function () {
          var params = {};
          $log.debug(vm.regtime, vm.regdate)

          var querytime = new Date(vm.regdate.getFullYear(), vm.regdate.getMonth(), vm.regdate.getDate(),
            vm.regtime.getHours(), vm.regtime.getMinutes(), vm.regtime.getSeconds());

          params['licenseNumber'] = vm.regid;
          params['querytime'] = querytime;

          $http.get("/inspector/parkingrights/",
            {
              params: params

            }
          ).then(function (response) {
            vm.regresponse = response.data;
            $log.debug(response.data);
          }, function (data) {
            $log.debug(data)
          })

        };
        vm.dateOptions = {
          'year-format': "yy",
          'starting-day': 1
        };
        vm.format = 'dd.MM.yyyy';
        vm.showWeeks = true;
        vm.toggleWeeks = function () {
          vm.showWeeks = !vm.showWeeks;
        };
        vm.dategiven = false;
        vm.dayreportopen = false;

        vm.opendategive = function ($event) {
          $event.preventDefault();
          $event.stopPropagation();
          vm.dategiven = true;
        };

        vm.reportdayopen = function ($event) {
          $event.preventDefault();
          $event.stopPropagation();
          vm.dayreportopen = true;
        };

      }]);


})();

(function () {
  'use strict';

  angular
    .module('office')
    .service('UserService', ["$window", function ($window) {
      var vm = this;
      vm.userdata = {
        key: "",
        userId: "",
        userRole: ""
      };

      vm.create = function (sessionId, userId, userRole) {
        vm.userdata.key = sessionId;
        vm.userdata.userId = userId;
        vm.userdata.userRole = userRole;
        if(userRole&&(userRole.includes("property")||userRole.includes("facilityservices"))){
              vm.userdata.limitedUser = true;
          }
        else {
          vm.userdata.limitedUser = false
        }
      };
      vm.getuserinfo = function () {
        return vm.userdata;
      };
      vm.destroy = function () {
        vm.userdata = {
          key: "",
          userId: "",
          userRole: ""
        };
        $window.sessionStorage.removeItem("user");
      };
    }])

})();

(function () {
  'use strict';

  angular
    .module('office')
    .service('permitServices', ['$http', 'UserService', '$log', '$q', function ($http, UserService, $log, $q) {
      return {
        getCustomer: function (id) {
          var deferred = $q.defer();
          $http.get("/utils/customer_detail/" + id).then(function (data) {
            deferred.resolve(data['data']);
            $log.debug("success", data);
          }, function (data) {

            $log.debug("ERROR", data);
            deferred.reject(data);
          });
          return deferred.promise;
        },
        deleteAttachement: function (file_id) {
          var deferred = $q.defer();
          $http.delete("/permits/permitfile/" + file_id +"/").then(function (data) {
            deferred.resolve(data['data']);
            $log.debug("success", data);
          }, function (data) {

            $log.debug("ERROR", data);
            deferred.reject(data);
          });
          return deferred.promise;
        },
        getCustomerProposals: function (firstname, lastname, companyname, registration_id) {
          var params = {
            firstname: firstname,
            lastname: lastname,
            companyname: companyname,
            registration_id: registration_id
          };
          var deferred = $q.defer();
          $http.get("/utils/proposed_customers", {
            params: params
          }).then(function (data) {
            deferred.resolve(data['data']);
          }, function (data) {

            $log.debug("ERROR", data);
            deferred.reject(data);
          });
          return deferred.promise;


        },
        deletePermitByContractNumber: function (contract_number) {
          var deferred = $q.defer();
          $http.delete("/permits/wwwpermit/contract_number/" + contract_number).then(function (data) {

            deferred.resolve(data);
          }, function (data) {

            $log.debug(data);
            deferred.reject(data);
          });
          return deferred.promise;
        },

        getPermitByContractNumber: function (contract_number) {
          var deferred = $q.defer();
          $http.get("/permits/wwwpermit/contract_number/" + contract_number).then(function (data) {

            deferred.resolve(data);
          }, function (data) {

            $log.debug(data);
            deferred.reject(data);
          });
          return deferred.promise;
        }, getparkingareas: function () {
          var deferred = $q.defer();
          $http.get("/utils/parkingareas").then(function (data) {
            deferred.resolve(data['data']['results']);
          }, function (data) {

            $log.debug(data);
            deferred.reject(data);
          });
          return deferred.promise;
        },
        getPermitById: function (permit_id) {
          var deferred = $q.defer();
          $http.get("/permits/wwwpermit/" + permit_id).then(function (data) {

            deferred.resolve(data);
          }, function (data) {

            $log.debug(data);
            deferred.reject(data);
          });
          return deferred.promise;
        },
        savePermit: function (permit) {
          var deferred = $q.defer();
          if (permit.id) {
            $http.put("/permits/wwwpermit/" + permit.id, permit).then(function (data) {
              $log.debug("existin permit", data);
              deferred.resolve(data);
            }, function (data) {

              $log.debug(data);
              deferred.reject(data);
            });
          } else {

            $http.post("/permits/wwwpermitcreate/", permit).then(function (data) {
              $log.debug("new permit", data);
              deferred.resolve(data);
            }, function (data) {

              $log.debug(data);
              deferred.reject(data);
            });
          }

          return deferred.promise;


        }

      }

    }])
})();

(function() {
  'use strict';

  angular
    .module('office')
    .filter('datetimeISOtoFinShort', [function() {
    return function(datetimeISOString) {
		if(!datetimeISOString){
			return "";
		}
        var timedate=new Date(datetimeISOString);
        var minutes = timedate.getMinutes();
        minutes = (timedate.getMinutes()<10?'0':'') + timedate.getMinutes();
        var timeString = ""+timedate.getDate()+"."+(timedate.getMonth()+1)+"."+timedate.getFullYear()+" "+ timedate.getHours()+":"+minutes;
        return timeString
    }
  }]).filter("multiline",[function() {
    return function(regids) {
		if(!regids){
			return "";
		}
        var regs = regids.split(",");

        return regs
    }
  }])

})();

(function () {
  'use strict';

  angular
    .module('office')
    .factory('AuthService', ['$state', '$window', '$http', 'UserService', '$log', '$q', function ($state, $window, $http, UserService, $log, $q) {

      function init() {
        // Lets fetch authentication data from session storage. So we can authenticate with existing data
        if ($window.sessionStorage["user"]) {
          var user = angular.fromJson($window.sessionStorage["user"]);
          UserService.create(user.key, user.userId, user.userRole);
          $http.defaults.headers.common.Authorization = 'Token ' + user.key;


        }
      }

      init();

      var authService = {};
      authService.login = function (credentials) {
        var deferred = $q.defer();
        $http.defaults.headers.common.Authorization = "";
        $http.post('/rest-auth/login/', credentials)
          .then(function (res) {
            $log.debug("authService",res)
            $http.defaults.headers.common.Authorization = 'Token ' + res.data.key;
            UserService.create(res.data.key, credentials.username, null);
            $window.sessionStorage["user"] = angular.toJson(UserService.getuserinfo());

            deferred.resolve(res);
          }, function (data) {
            deferred.reject(data);

          });
        return deferred.promise

      };
      authService.logout = function () {
        $http.post("/rest-auth/logout/").then(function () {
            $http.defaults.headers.common.Authorization = "";
            UserService.destroy();
            $state.transitionTo("login");

          }, function (data) {
            $log.debug("authservice.logout", data)
          }
        )
      };
      authService.getuserdata =  function () {
          var deferred = $q.defer();
          $http.get("/utils/userinfos").then(function (data) {
            var lista = data.data.results.map(function(item){return item['name']});
            var userdata = UserService.getuserinfo();
            UserService.create(userdata.key,userdata.userId,lista);
            $window.sessionStorage["user"] = angular.toJson(UserService.getuserinfo());
            deferred.resolve(data['data']['results']);
          }, function (data) {

            $log.debug(data);
            deferred.reject(data);
          });
          return deferred.promise;
        };

      authService.isAuthenticated = function () {
        var userdata = UserService.getuserinfo();
        $log.debug("isauthenticated", userdata);
        return userdata.key;
      };

      authService.isAuthorized = function (authorizedRoles) {
        if (!angular.isArray(authorizedRoles)) {
          authorizedRoles = [authorizedRoles];
        }
        return (authService.isAuthenticated() &&
        authorizedRoles.indexOf(UserService.userRole) !== -1);
      };

      return authService;
    }])
    .service('authInterceptor', ['$q', '$injector', 'UserService', function ($q, $injector, UserService) {
      var service = this;
      service.responseError = function (response) {
        if (response.status == 401) {
          //AuthService.logout();
          var stateService = $injector.get('$state');
          UserService.destroy();
          stateService.go('login');

        }
        return $q.reject(response);
      };
    }])
    .config(['$httpProvider', function ($httpProvider) {
      $httpProvider.interceptors.push('authInterceptor');
    }])

})();

(function () {
  'use strict';

  angular
    .module('office')
    .controller('PermitsListController', ['$timeout','$state' ,function ($timeout, $state) {
      var vm = this;
      vm.getNewPermit = function () {
        $state.go("permitparking.permiteditor", {permitID: -1});
      };

    }]);

})();

(function () {
  'use strict';

  angular
    .module('office')
    .controller('PermitEditorController', ['$stateParams', '$log', 'permitServices', '$state', '$window', 'UserService',
      'Upload', '$timeout', '$uibModal','$scope','AUTH_EVENTS',
      function ($stateParams, $log, permitServices, $state, $window, UserService, Upload, $timeout, $uibModal,
                $scope, AUTH_EVENTS) {

        var permitID = $stateParams.permitID;
        var contract_number = $stateParams.contract_number;
        var vm = this;
        vm.limitedUser = UserService.userdata.limitedUser;
        vm.userRoles = UserService.userdata.userRole;
        $scope.$on(AUTH_EVENTS.userRolesFetched, function() {
          vm.userRoles = UserService.userdata.userRoles;
          });
        permitServices.getparkingareas().then(function (data) {
          $log.debug("succeeded", data);
          vm.parkingareas = data;
          vm.filteredParkingAreas = getFilteredParkingAreas(vm.parkingareas, vm.permit.permit_type)
        }, function (data) {
          $log.debug("parkingarea search failed", data);
          vm.filteredParkingAreas = []
        });

        vm.endtime_changed = function() {
          var cmp_day = getdaysahead(14, vm.permit.permit_start);
          vm.date_error = false;
          if(vm.permit.permit_end > cmp_day&&vm.userRoles.includes("property")){
            vm.permit.permit_end = new Date(cmp_day);
            vm.date_error = true;
          }
        }

        vm.permit = {};
        vm.permit.customer = {};
        vm.customer = {};

        vm.calc_months = function (date, months) {
          // eslint-disable-next-line no-undef,no-undef
          var endDateMoment = moment(date); // moment(...) can also be used to parse dates in string format
          endDateMoment.add(months, 'months');
          endDateMoment.add(-1,'days');
          return new Date(endDateMoment);
        };


        vm.period_changed = function (ext) {
          if (ext) {
            vm.permit.permit_end = vm.calc_months(vm.permit.permit_start, ext);
          }

        };

        vm.mandatory_all = {
          "1": {
            "extrainformation": false,
            "parking_area_name": true,
            "regid": true,
            "residentialID": true,
            "starttime": true,
            "endtime": true,
            "customertype":true,
            "firstname": true,
            "lastname": true,
            "companyname": false,
            "tunnus": false,
            "streetaddress": true,
            "zipcode": true,
            "city": true,
            "telephonenumber": false,
            "email": false,
            "firstextra": false,
            "secondextra": false,
            "allow_email": true,
            "allow_sms": true,
            "billing_name": false,
            "billing_companyname": false,
            "billing_streetaddress": false,
            "billing_zipcode": false,
            "billing_city": false,
            "granted_by": false
          },
          "2": {
            "extrainformation": false,
            "parking_area_name": true,
            "residentialID": true,
            "starttime": true,
            "endtime": true,
            "customertype":true,
            "firstname": false,
            "lastname": false,
            "companyname": true,
            "tunnus": false,
            "streetaddress": true,
            "zipcode": true,
            "city": true,
            "telephonenumber": false,
            "email": false,
            "firstextra": false,
            "secondextra": false,
            "allow_email": true,
            "allow_sms": true,
            "billing_name": false,
            "billing_companyname": false,
            "billing_streetaddress": false,
            "billing_zipcode": false,
            "billing_city": false,
            "granted_by": false
          },
          "3": {
            "extrainformation": false,
            "parking_area_name": true,
            "residentialID": true,
            "starttime": true,
            "endtime": true,
            "customertype":true,
            "firstname": true,
            "lastname": true,
            "companyname": false,
            "tunnus": false,
            "streetaddress": true,
            "zipcode": true,
            "city": true,
            "telephonenumber": false,
            "email": false,
            "firstextra": false,
            "secondextra": false,
            "allow_email": true,
            "allow_sms": true,
            "billing_name": true,
            "billing_companyname": true,
            "billing_streetaddress": true,
            "billing_zipcode": true,
            "billing_city": true,
            "granted_by": false
          },
          "4": { // mittarilupa
            "permitvalidity_in_months": false ,
            "permit_validity_6_12": false,
            "customertype": false,
            "visible_parking_areas": [5],
            "show_billing_address": false,
            "parking_area_name": true,
            "residentialID": false,
            "starttime": true,
            "endtime": true,
            "firstname": true,
            "lastname": true,
            "companyname": true,
            "tunnus": false,
            "streetaddress": true,
            "zipcode": true,
            "city": true,
            "telephonenumber": false,
            "email": false,
            "firstextra": false,
            "secondextra": false,
            "granted_by": false
          },
          "5": { // Kuopion kaupunki
            "permitvalidity_in_months": false ,
            "permit_validity_6_12": false,
            "customertype": false,
            "visible_parking_areas": [5],
            "show_billing_address": false,
            "parking_area_name": true,
            "residentialID": false,
            "starttime": true,
            "endtime": true,
            "firstname": true,
            "lastname": true,
            "companyname": false,
            "tunnus": false,
            "streetaddress": false,
            "zipcode": false,
            "city": false,
            "telephonenumber": false,
            "email": false,
            "firstextra": false,
            "secondextra": false,
            "granted_by": false
          },
          "6": { // IGL
            "permitvalidity_in_months": false ,
            "permit_validity_6_12": false,
            "customertype": false,
            "visible_parking_areas": [5],
            "show_billing_address": false,
            "parking_area_name": true,
            "residentialID": false,
            "starttime": true,
            "endtime": true,
            "firstname": false,
            "lastname": false,
            "companyname": false,
            "tunnus": false,
            "streetaddress": false,
            "zipcode": false,
            "city": false,
            "telephonenumber": false,
            "email": false,
            "firstextra": false,
            "secondextra": false,
            "granted_by": false
          },
          "7": { // Hoitopysäköintilupa
            "permitvalidity_in_months": false ,
            "permit_validity_6_12": false,
            "customertype": false,
            "visible_parking_areas": [5],
            "show_billing_address": false,
            "parking_area_name": true,
            "residentialID": false,
            "starttime": true,
            "endtime": true,
            "firstname": true,
            "lastname": true,
            "companyname": false,
            "tunnus": true,
            "streetaddress": false,
            "zipcode": false,
            "city": false,
            "telephonenumber": false,
            "email": false,
            "firstextra": false,
            "secondextra": false,
            "granted_by": false
          },
          "8": {
            // satama-alue
            "permitvalidity_in_months": false,
            "permit_validity_6_12": false,
            "customertype": true,
            "visible_parking_areas": [],
            "show_billing_address": false,
            "parking_area_name": true,
            "residentialID": false,
            "starttime": true,
            "endtime": true,
            "firstname": true,
            "lastname": true,
            "companyname": true,
            "tunnus": false,
            "streetaddress": false,
            "zipcode": false,
            "city": false,
            "telephonenumber": false,
            "email": false,
            "firstextra": false,
            "secondextra": false,
            "granted_by": false
          },
          "9": {
            // liikkuva työ
            "permitvalidity_in_months": false,
            "permit_validity_6_12": false,
            "customertype": false,
            "visible_parking_areas": [],
            "show_billing_address": false,
            "parking_area_name": true,
            "residentialID": false,
            "starttime": true,
            "endtime": true,
            "firstname": true,
            "lastname": true,
            "companyname": false,
            "tunnus": false,
            "streetaddress": false,
            "zipcode": false,
            "city": false,
            "telephonenumber": false,
            "email": false,
            "firstextra": false,
            "secondextra": false,
            "granted_by": false
          },
          "10": {
            // kunnossapito
            "permitvalidity_in_months": false,
            "permit_validity_6_12": false,
            "customertype": true,
            "visible_parking_areas": [],
            "show_billing_address": false,
            "parking_area_name": true,
            "residentialID": false,
            "starttime": true,
            "endtime": true,
            "firstname": true,
            "lastname": true,
            "companyname": true,
            "tunnus": false,
            "streetaddress": false,
            "zipcode": false,
            "city": false,
            "telephonenumber": true,
            "email": false,
            "firstextra": false,
            "secondextra": false,
            "granted_by": false
          },
          "11": {
            // tilakeskus
            "permitvalidity_in_months": false,
            "permit_validity_6_12": false,
            "customertype": true,
            "visible_parking_areas": [],
            "show_billing_address": false,
            "parking_area_name": true,
            "residentialID": false,
            "starttime": true,
            "endtime": true,
            "firstname": true,
            "lastname": true,
            "companyname": true,
            "tunnus": false,
            "streetaddress": false,
            "zipcode": false,
            "city": false,
            "telephonenumber": true,
            "email": false,
            "firstextra": false,
            "secondextra": false,
            "granted_by": true
          },
          "12": {
            // poikkeustila
            "permitvalidity_in_months": false,
            "permit_validity_6_12": false,
            "customertype": true,
            "visible_parking_areas": [],
            "show_billing_address": false,
            "parking_area_name": true,
            "residentialID": false,
            "starttime": true,
            "endtime": true,
            "firstname": true,
            "lastname": true,
            "companyname": false,
            "tunnus": false,
            "streetaddress": false,
            "zipcode": false,
            "city": false,
            "telephonenumber": true,
            "email": false,
            "firstextra": false,
            "secondextra": false,
            "granted_by": false
          },
          "13": {
            // Päivälupa
            "permitvalidity_in_months": false,
            "permit_validity_6_12": false,
            "customertype": false,
            "visible_parking_areas": [],
            "show_billing_address": false,
            "parking_area_name": true,
            "residentialID": false,
            "starttime": true,
            "endtime": true,
            "firstname": true,
            "lastname": true,
            "companyname": false,
            "tunnus": false,
            "streetaddress": false,
            "zipcode": false,
            "city": false,
            "telephonenumber": false,
            "email": false,
            "firstextra": false,
            "secondextra": false,
            "granted_by": false
          }
        };

        vm.visible_all = {
          "1": {
            "extrainformation": true,
            "permit_validity_6_12": true,
            "permitvalidity_in_months": false,
            "customertype": false,
            "visible_parking_areas": [1],
            "namedparkingplace": true,
            "parking_area_visible":true,
            "parking_area_selection":true,
            "show_billing_address": false,
            "parking_area_name": true,
            "registration_id": true,
            "residentialID": true,
            "starttime": true,
            "endtime": true,
            "firstname": true,
            "lastname": true,
            "companyname": false,
            "tunnus": true,
            "streetaddress": true,
            "zipcode": true,
            "city": true,
            "telephonenumber": true,
            "email": true,
            "firstextra": true,
            "secondextra": true,
            "additionalusers":true,
            "permissionsvisible":true,
            "granted_by": false
          },
          "2": {
            "extrainformation": true,
            "permit_validity_6_12": true,
            "customertype": false,
            "visible_parking_areas": [1, 2],
            "namedparkingplace": true,
            "parking_area_visible":true,
            "parking_area_selection":true,
            "show_billing_address": false,
            "parking_area_name": true,
            "residentialID": true,
            "registration_id":true,
            "starttime": true,
            "endtime": true,
            "firstname": true,
            "lastname": true,
            "companyname": true,
            "tunnus": true,
            "streetaddress": true,
            "zipcode": true,
            "city": true,
            "telephonenumber": true,
            "email": true,
            "firstextra": true,
            "secondextra": true,
            "additionalusers":true,
            "permissionsvisible":true,
            "granted_by": false
          },
          "3": {
            "extrainformation": true,
            "permitvalidity_in_months": true,
            "permit_validity_6_12": false,
            "customertype": true,
            "visible_parking_areas": [1],
            "namedparkingplace": true,
            "parking_area_visible":true,
            "parking_area_selection":true,
            "show_billing_address": true,
            "parking_area_name": true,
            "registration_id":true,
            "residentialID": true,
            "starttime": true,
            "endtime": true,
            "firstname": true,
            "lastname": true,
            "companyname": true,
            "tunnus": true,
            "streetaddress": true,
            "zipcode": true,
            "city": true,
            "telephonenumber": true,
            "email": true,
            "firstextra": true,
            "secondextra": true,
            "additionalusers":false,
            "permissionsvisible":true,
            "granted_by": false
          },
          "4": {
            "extrainformation": true,
            "permitvalidity_in_months": true,
            "permit_validity_6_12": true,
            "customertype": true,
            "visible_parking_areas": [1],
            "namedparkingplace": true,
            "parking_area_visible":true,
            "parking_area_selection":true,
            "show_billing_address": true,
            "parking_area_name": true,
            "residentialID": true,
            "registration_id":true,
            "starttime": true,
            "endtime": true,
            "firstname": true,
            "lastname": true,
            "companyname": true,
            "tunnus": true,
            "streetaddress": true,
            "zipcode": true,
            "city": true,
            "telephonenumber": true,
            "email": true,
            "firstextra": true,
            "secondextra": true,
            "additionalusers":false,
            "permissionsvisible":true,
            "granted_by": false
          },
          "5": {  // Kuopio henkilöstöpysäköintilupa
            "extrainformation": true,
            "permitvalidity_in_months": false ,
            "permit_validity_6_12": false,
            "customertype": false,
            "visible_parking_areas": [5],
            "namedparkingplace": true,
            "parking_area_visible":true,
            "parking_area_selection":true,
            "show_billing_address": false,
            "parking_area_name": true,
            "registration_id":true,
            "residentialID": false,
            "starttime": true,
            "endtime": true,
            "firstname": true,
            "lastname": true,
            "companyname": false,
            "tunnus": false,
            "streetaddress": false,
            "zipcode": false,
            "city": false,
            "telephonenumber": false,
            "email": false,
            "firstextra": false,
            "secondextra": false,
            "additionalusers":false,
            "permissionsvisible":false,
            "granted_by": false
          },
          "6": {  //IGL
            "permitvalidity_in_months": false ,
            "permit_validity_6_12": false,
            "customertype": false,
            "visible_parking_areas": [5],
            "namedparkingplace": true,
            "parking_area_visible":true,
            "parking_area_selection":true,
            "show_billing_address": false,
            "parking_area_name": true,
            "residentialID": false,
            "starttime": true,
            "endtime": true,
            "firstname": false,
            "lastname": false,
            "companyname": false,
            "tunnus": false,
            "streetaddress": false,
            "zipcode": false,
            "city": false,
            "telephonenumber": false,
            "email": false,
            "firstextra": false,
            "secondextra": false,
            "additionalusers":false,
            "permissionsvisible":false
          },
          "7": {  // Hoitopysäköintilupa
            "permitvalidity_in_months": false ,
            "permit_validity_6_12": false,
            "customertype": false,
            "visible_parking_areas": [5],
            "parking_area_visible":false,
            "parking_area_selection":false,
            "namedparkingplace": false,
            "show_billing_address": false,
            "parking_area_name": true,
            "residentialID": false,
            "starttime": true,
            "endtime": true,
            "firstname": true,
            "lastname": true,
            "companyname": false,
            "tunnus": false,
            "streetaddress": false,
            "zipcode": false,
            "city": false,
            "telephonenumber": false,
            "email": false,
            "firstextra": false,
            "secondextra": false,
            "additionalusers":false,
            "permissionsvisible":false,
            "extrainformation":true
          },
          "8": {
            // satama-alue
            "extrainformation": true,
            "permitvalidity_in_months": false,
            "permit_validity_6_12": false,
            "customertype": true,
            "visible_parking_areas": [],
            "namedparkingplace": false,
            "show_billing_address": false,
            "parking_area_visible": true,
            "residentialID": false,
            "starttime": true,
            "endtime": true,
            "firstname": true,
            "lastname": true,
            "companyname": true,
            "tunnus": false,
            "streetaddress": false,
            "zipcode": false,
            "city": false,
            "telephonenumber": false,
            "email": false,
            "firstextra": false,
            "secondextra": false,
            "additionalusers":false,
            "permissionsvisible":false,
            "granted_by": false
          },
          "9": {
            // liikkuva työ
            "extrainformation": true,
            "permitvalidity_in_months": false,
            "permit_validity_6_12": false,
            "customertype": false,
            "visible_parking_areas": [],
            "namedparkingplace": true,
            "show_billing_address": false,
            "parking_area_visible": false,
            "residentialID": false,
            "starttime": true,
            "endtime": true,
            "firstname": true,
            "lastname": true,
            "companyname": false,
            "tunnus": false,
            "streetaddress": false,
            "zipcode": false,
            "city": false,
            "telephonenumber": false,
            "email": false,
            "firstextra": false,
            "secondextra": false,
            "additionalusers":false,
            "permissionsvisible":false,
            "granted_by": false
          },
          "10": {
            // kunnossapito
            "extrainformation": true,
            "permitvalidity_in_months": false,
            "permit_validity_6_12": false,
            "customertype": true,
            "namedparkingplace": true,
            "visible_parking_areas": [],
            "show_billing_address": false,
            "parking_area_visible": false,
            "residentialID": false,
            "starttime": true,
            "endtime": true,
            "firstname": true,
            "lastname": true,
            "companyname": true,
            "tunnus": false,
            "streetaddress": false,
            "zipcode": false,
            "city": false,
            "telephonenumber": true,
            "email": false,
            "firstextra": false,
            "secondextra": false,
            "additionalusers":false,
            "permissionsvisible":false,
            "granted_by": false
          },
          "11": {
            // tilakeskus
            "extrainformation": true,
            "permitvalidity_in_months": false,
            "permit_validity_6_12": false,
            "customertype": true,
            "visible_parking_areas": [],
            "namedparkingplace": false,
            "show_billing_address": false,
            "parking_area_visible": false,
            "residentialID": false,
            "starttime": true,
            "endtime": true,
            "firstname": true,
            "lastname": true,
            "companyname": true,
            "tunnus": false,
            "streetaddress": false,
            "zipcode": false,
            "city": false,
            "telephonenumber": false,
            "email": false,
            "firstextra": false,
            "secondextra": false,
            "additionalusers":false,
            "permissionsvisible":false,
            "granted_by": true
          },
          "12": {
            // poikkeustila
            "extrainformation": true,
            "permitvalidity_in_months": false,
            "permit_validity_6_12": false,
            "customertype": true,
            "visible_parking_areas": [],
            "namedparkingplace": true,
            "show_billing_address": false,
            "parking_area_visible": false,
            "residentialID": false,
            "starttime": true,
            "endtime": true,
            "firstname": true,
            "lastname": true,
            "companyname": true,
            "tunnus": false,
            "streetaddress": false,
            "zipcode": false,
            "city": false,
            "telephonenumber": true,
            "email": false,
            "firstextra": false,
            "secondextra": false,
            "additionalusers":false,
            "permissionsvisible":false,
            "granted_by": false
          },
          "13": {
            // päivälupa
            "extrainformation": true,
            "permitvalidity_in_months": false,
            "permit_validity_6_12": false,
            "customertype": false,
            "visible_parking_areas": [],
            "namedparkingplace": true,
            "show_billing_address": false,
            "parking_area_visible": false,
            "residentialID": false,
            "starttime": true,
            "endtime": true,
            "firstname": true,
            "lastname": true,
            "companyname": false,
            "tunnus": false,
            "streetaddress": false,
            "zipcode": false,
            "city": false,
            "telephonenumber": false,
            "email": false,
            "firstextra": false,
            "secondextra": false,
            "additionalusers":false,
            "permissionsvisible":false,
            "granted_by": false
          }
        };

        vm.placeTypes = [{key: 1, value: "nimetty lämpötolppapaikka"},{key:2 ,value:"nimeämätön lämpötolppapaikka"},
          {key: 3, value: "nimetty paikka"},{key: 4, value: "nimeämätön paikka"},
          {key: 5,value: "määrittelemätön"}];

        if(vm.userRoles.includes("property")){
          vm.permittypes = [{key: "13", value: "Päivälupa"}];
          vm.permit.permit_type = "13";

        } else if(vm.userRoles.includes("facilityservices")){
          vm.permittypes = [{key: "11", value: "Tilapalvelut"}];
          vm.permit.permit_type = "11";
          vm.visible_all['11']['granted_by'] = false;
          vm.mandatory_all['11']['granted_by'] = false;
        } else
        {
          vm.permittypes = [
            {key: "1", value: 'Asukas'},
            {key: "2", value: 'Yritys'},
            {key: "3", value: "Pysäköintilaitoksen kuukausikortti"},
            {key: "4", value: 'Mittarilupa'},
            {key: "5", value: 'Henkilöstölupa'},
            {key: "6", value: 'IGL'},
            {key: "7", value: 'Hoitopysäköintilupa'},
            {key: "8", value: 'Satama-alue'},
            {key: "9", value: "Liikkuva työ"},
            {key: "10", value: "Kunnossapito"},
            {key: "11", value: "Tilapalvelut"},
            {key: "12", value: "Poikkeustila"},
            {key: "13", value: "Päivälupa"}
          ];
          vm.permit.permit_type = "1";
        }
        vm.permit.customer.customer_type = "1"

        if(vm.userRoles.includes('property')){
          vm.permit.permit_end = new Date();
        } else {
          vm.period_changed(6);
        }


        vm.permitchanged = function (key){
          $log.debug('permitTypeChanged, permit_type:', vm.permit.permit_type, key);
          vm.mandatory = vm.mandatory_all[vm.permit.permit_type];
          vm.visible = vm.visible_all[parseInt(vm.permit.permit_type)];
          vm.filteredParkingAreas = getFilteredParkingAreas(vm.parkingareas, vm.permit.permit_type);
          switch (vm.permit.permit_type) {
            case "2":
            case "10":  // kunnossapito
              if(vm.permit.customer) {
                vm.permit.customer.customertype = "2";
                $log.debug('   customer_type --->', vm.permit.customer.customertype);
              }
              break;
            case "8":  // satama-alue
              vm.permit.permit_end = vm.getLastDayOfYear();
              $log.debug('   permit_end --->', vm.permit.permit_end);
              break;
            case "13":  // päivälupa
              vm.permit.permit_end = vm.permit.permit_start;
              $log.debug('   permit_end --->', vm.permit.permit_end);
              break;
          }
        }

        if (permitID && permitID > 0) {
          permitServices.getPermitById(permitID).then(function (data) {
            vm.permit = data['data'];
            $log.debug("permitdata", vm.permit);
            if (vm.permit.permit_type && angular.isNumber(vm.permit.permit_type)) {
              vm.permit.permit_type = vm.permit.permit_type.toString();
            }
            vm.permit.placeType = ""+vm.permit.placeType;
            if (vm.permit.permit_start != null) {
              vm.permit.permit_start = new Date(vm.permit.permit_start);
              vm.permit.permit_start.setTime(vm.permit.permit_start.getTime()+ 43200000)
            }
            if(vm.permit.permit_type){
              vm.permit.permit_type = "" + (vm.permit.permit_type);
            }
            if (vm.permit.permit_end != null) {
              vm.permit.permit_end = new Date(vm.permit.permit_end);
              vm.permit.permit_end.setTime(vm.permit.permit_end.getTime()+ 43200000);
            }
            vm.filteredParkingAreas = getFilteredParkingAreas(vm.parkingareas, vm.permit.permit_type)
            vm.mandatory = vm.mandatory_all[parseInt(vm.permit.permit_type)];
            vm.visible = vm.visible_all[parseInt(vm.permit.permit_type)];
          }, function (data) {
            $log.debug(data);
          })
        } else if (!permitID) {
          $state.go("home");
        } else if (permitID === -1&&contract_number>0) {
          permitServices.getPermitByContractNumber(contract_number).then(function (data) {
            vm.permit = data['data'];
            // if (vm.permit.permit_type && angular.isNumber(vm.permit.permit_type)) {
            //   vm.permit.permit_type = vm.permit.permit_type.toString();
            // }
            if (vm.permit.permit_start != null) {
              vm.permit.permit_start = new Date(vm.permit.permit_start);
              vm.permit.permit_start.setTime(vm.permit.permit_start.getTime()+ 43200000)
            }
            if (vm.permit.permit_end != null) {
              vm.permit.permit_end = new Date(vm.permit.permit_end);
              vm.permit.permit_end.setTime(vm.permit.permit_end.getTime()+ 43200000)
            }
            vm.mandatory = vm.mandatory_all[parseInt(vm.permit.permit_type)];
            vm.visible = vm.visible_all[parseInt(vm.permit.permit_type)];
          }, function (data) {
            $log.debug(data);
            $uibModal.open(
            {

              /*
               This is new way of using generic modal window. This is accompanied with gendialog component. use ui.bootstrap
               method $uibModal.open to create modal window which content is coming from gen-dialog component. The parameters
               are:
               agree : requires function as parameter - this is bind to agree-button aka actionbuttontext
               dismiss: requires function as paramenter - this is bind to cancel-button
               headingtext: requires string and this is the title of dialog window
               explanation: This informative information for dialog reader. it is string placed in <p></p>
               okvisible: Boolean. if true, then button is visible
               cancelvisible: Boolean. if true, then button is visible
               actionbuttontext: String. text shown in agree button
               cancelbuttontext: String. Text shown in cancel button
               */
              template: '<gen-dialog agree="$ctrl.agree();$close();" dismiss="$dismiss()" headingtext="Ei löytynyt" explanation="{{$ctrl.explanation}}" ' +
              'okvisible="true", actionbuttontext="Sulje", cancelvisible="false", closebuttontext="Peruuta"  ></gen-dialog>',
              controller: function () {
                var vm = this;
                vm.explanation = "Pysäköintisopimusta ei tällä numerolla löytynyt";
                vm.agree = function () {
                $window.history.back();
                }
              },
              controllerAs: '$ctrl',
              windowClass: 'app-gen-dialog'
            });
          })


        }
        else {
          vm.mandatory = vm.mandatory_all[parseInt(vm.permit.permit_type)];
          vm.visible = vm.visible_all[parseInt(vm.permit.permit_type)];
          vm.permit.permit_start = new Date();
          vm.end_extension = "6";
          vm.permitvalidity_in_months = "6";
                  if(vm.userRoles.includes('property')){
          vm.permit.permit_end = new Date();
        } else {
          vm.period_changed(6);
        }


        }
        if (!vm.permit.parking_area) {
          vm.permit.parking_area = [];
        }

        vm.renew_permit = function(){
          $uibModal.open(
            {

              /*
               This is new way of using generic modal window. This is accompanied with gendialog component. use ui.bootstrap
               method $uibModal.open to create modal window which content is coming from gen-dialog component. The parameters
               are:
               agree : requires function as parameter - this is bind to agree-button aka actionbuttontext
               dismiss: requires function as paramenter - this is bind to cancel-button
               headingtext: requires string and this is the title of dialog window
               explanation: This informative information for dialog reader. it is string placed in <p></p>
               okvisible: Boolean. if true, then button is visible
               cancelvisible: Boolean. if true, then button is visible
               actionbuttontext: String. text shown in agree button
               cancelbuttontext: String. Text shown in cancel button
               */
              template: '<gen-dialog agree="$ctrl.agree();$close();" dismiss="$dismiss()" headingtext="Uudista sopimus" explanation="{{$ctrl.explanation}}" ' +
              'okvisible="true", actionbuttontext="Uuudista", cancelvisible="true", closebuttontext="Peruuta"  ></gen-dialog>',
              controller: function () {
                var cp = this;
                cp.explanation = "Haluatko uudistaa tämän luvan? Tarkista tiedot, ja voimassaoloaika ja paina tallenna luodaksesi uusi pysäköintiä koskeva sopimus näillä tiedoilla. Voit myös tulostaa ja tallentaa";
                cp.agree = function () {
          vm.permit.id = null;
                  // eslint-disable-next-line no-undef
          var permit_start = moment(vm.permit.permit_start);
          var permit_end = moment(vm.permit.permit_end);
          var duration = permit_end.diff(permit_start, "months");
          vm.permit.permit_start = vm.permit.permit_end;
          vm.period_changed(duration);
                }
              },
              controllerAs: '$ctrl',
              windowClass: 'app-gen-dialog'
            });
        };

        vm.permit_start_changed = function () {
          var ptype = vm.permit.permit_type;
          var ext;
          if (ptype == "1" || ptype == "2") {
            ext = vm.end_extension;
            if (ext) {
              vm.permit.permit_end = vm.calc_months(vm.permit.permit_start, ext);
            }
          } else {
            ext = vm.permitvalidity_in_months;
            if (ext) {

              vm.permit.permit_end = vm.calc_months(vm.permit.permit_start, ext);
            }
          }


        };


        vm.get_permitfile = function (file_id) {
          $window.open("/permits/permitfile/" + file_id);

        };
        vm.removeParkingArea = function (index) {
          vm.permit.parking_area.splice(vm.permit.parking_area[index], 1);
        };

        vm.add_parkingarea = function (index) {
          $log.debug(index, vm.selected_area);
          for (var a in vm.permit.parking_area) {
            if (vm.permit.parking_area[a].parkingareaid === vm.selected_area) {
              return;
            }
          }
          for (var i in vm.parkingareas) {
            if (vm.parkingareas[i].parkingareaid === vm.selected_area) {
              vm.permit.parking_area.push(vm.parkingareas[i]);
            }
          }
        };

        vm.uploadFiles = function (file, errFiles) {
          if(!vm.permit.permit_file){
            vm.permit.permit_file = [];
          }
          if (vm.permit.id) {
            vm.f = file;
            vm.errFile = errFiles && errFiles[0];
            if (file) {
              file.upload = Upload.upload({
                url: '/permits/uploadfile/' + vm.permit.id,
                data: {file: file, filepurpose: "signature"}
              });

              file.upload.then(function (response) {
                $timeout(function () {
                  file.result = response.data;
                  var data = response.data;
                  vm.permit.permit_file.push({
                    "id": data['fid'],
                    "originalname": data['originalname'],
                    "filepurpose": data['filepurpose']
                  })
                });
              }, function (response) {
                if (response.status > 0)
                  vm.errorMsg = response.status + ': ' + response.data;
              }, function (evt) {
                file.progress = Math.min(100, parseInt(100.0 *
                  evt.loaded / evt.total));
              });
            }
          }
        };

        vm.cancel = function () {
          $window.history.back();
        };

        vm.deleteattachementfile = function (index) {
          $uibModal.open(
            {

              /*
               This is new way of using generic modal window. This is accompanied with gendialog component. use ui.bootstrap
               method $uibModal.open to create modal window which content is coming from gen-dialog component. The parameters
               are:
               agree : requires function as parameter - this is bind to agree-button aka actionbuttontext
               dismiss: requires function as paramenter - this is bind to cancel-button
               headingtext: requires string and this is the title of dialog window
               explanation: This informative information for dialog reader. it is string placed in <p></p>
               okvisible: Boolean. if true, then button is visible
               cancelvisible: Boolean. if true, then button is visible
               actionbuttontext: String. text shown in agree button
               cancelbuttontext: String. Text shown in cancel button
               */
              template: '<gen-dialog agree="$ctrl.agree();$close();" dismiss="$dismiss()" headingtext="Poista tiedosto" explanation="{{$ctrl.explanation}}" ' +
              'okvisible="true", actionbuttontext="Poista", cancelvisible="true", closebuttontext="Peruuta"  ></gen-dialog>',
              controller: function () {
                // eslint-disable-next-line angular/controller-as-vm
                var cp = this;
                cp.explanation = "Haluatko todella poistaa liitteet? Et voi peruuttaa poistamista";
                cp.agree = function () {
                  permitServices.deleteAttachement(vm.permit.permit_file[index].id).then(function () {

                    vm.permit.permit_file.splice(index, 1);
                    $uibModal.open({

                      template: '<gen-dialog dismiss="$dismiss()" headingtext="Liitteen poisto onnistui" explanation="{{$ctrl.explanation}}" okvisible="false", cancelvisible="true", ' +
                      'closebuttontext="OK"  ></gen-dialog>',
                      controller: function () {
                        var vm = this;
                        vm.explanation = "Liite poistettu";
                      },
                      controllerAs: '$ctrl',
                      windowClass: 'app-gen-dialog'
                    });

                  }, function (data) {
                    $uibModal.open({
                      template: '<gen-dialog dismiss="$dismiss()" headingtext="Liitteen poisto epäonnistui" explanation="{{$ctrl.explanation}}" okvisible="false", actionbuttontext="", cancelvisible="true", closebuttontext="OK"  ></gen-dialog>',
                      controller: function () {
                        var vm = this;
                        vm.explanation = "Liitteen poisto epäonnistui. Syy: " + data;
                      },
                      controllerAs: '$ctrl',
                      windowClass: 'app-gen-dialog'
                    })
                  })

                }
              },
              controllerAs: '$ctrl',
              windowClass: 'app-gen-dialog'
            });
        };
        vm.save_print = function () {
          var permit = angular.copy(vm.permit);
          if (vm.permit.permit_start) {
            permit.permit_start = vm.permit.permit_start.toJSON().slice(0, 10);
          }
          if (vm.permit.permit_end) {
            permit.permit_end = vm.permit.permit_end.toJSON().slice(0, 10);
          }
          // if(!vm.permit.firstname&&!vm.permit.lastname&&!vm.permit.companyname){
          //   delete(permit.customer)
          // }
          permitServices.savePermit(permit).then(function (data) {
            vm.permit.id = data.data.id;
            vm.permit.customer.id = data.data.customer.id;
            var u = UserService.getuserinfo();
            var params = {access_token: u.key};
            var url = ["/permits/printpermit/" + data.data.id, $.param(params)].join('?');
            $window.open(url);
          }, function (data) {
            $log.debug(data);
            alert("Virhe, ei voitu tallentaa asukaslupaa");
            //$log.debug(data);
          });


        };

        vm.remove_permit = function(){
            $uibModal.open(
            {

              /*
               This is new way of using generic modal window. This is accompanied with gendialog component. use ui.bootstrap
               method $uibModal.open to create modal window which content is coming from gen-dialog component. The parameters
               are:
               agree : requires function as parameter - this is bind to agree-button aka actionbuttontext
               dismiss: requires function as paramenter - this is bind to cancel-button
               headingtext: requires string and this is the title of dialog window
               explanation: This informative information for dialog reader. it is string placed in <p></p>
               okvisible: Boolean. if true, then button is visible
               cancelvisible: Boolean. if true, then button is visible
               actionbuttontext: String. text shown in agree button
               cancelbuttontext: String. Text shown in cancel button
               */
              template: '<gen-dialog agree="$ctrl.agree();$close();" dismiss="$dismiss()" headingtext="{{$ctrl.headingtext}}" explanation="{{$ctrl.explanation}}" ' +
              'okvisible="true", actionbuttontext="Poista", cancelvisible="true", closebuttontext="Peruuta"  ></gen-dialog>',
              controller: function () {
                var tp = this;
                tp.headingtext = "Pysäköintiluvan poisto";
                tp.explanation = "Oletko varma, että haluat poistaa tämän pysäköintiluvan? Et voi palauttaa poistettua lupaa";
                tp.agree = function () {
                  permitServices.deletePermitByContractNumber(vm.permit.id).then(function(data){
                    $log.debug(data);
                    $window.history.back();
                  }, function(result){
                    $log.debug("poistettu lupa", result);
                      $uibModal.open({
                      template: '<gen-dialog dismiss="$dismiss()" headingtext="Virhe" explanation="{{$ctrl.explanation}}" okvisible="false", actionbuttontext="", cancelvisible="true", closebuttontext="OK"  ></gen-dialog>',
                      controller: function () {
                        var vm = this;
                        vm.explanation = "Luvan poisto epäonnistui. Ota yhteyttä tekniseen tukeen. Virhe: "+ result.status;

                      },
                      controllerAs: '$ctrl',
                      windowClass: 'app-gen-dialog'
                    })

                  })
                }
              },
              controllerAs: '$ctrl',
              windowClass: 'app-gen-dialog'
            });


        };

        vm.save = function () {

          var permit = angular.copy(vm.permit);
          if (vm.permit.permit_start) {

            permit.permit_start = vm.permit.permit_start.toJSON().slice(0, 10);
          }
          if (vm.customer.firstname && vm.customer.firstname.size()===0){
            delete vm.customer.firstname;
          }
          if (vm.permit.permit_end) {
            permit.permit_end = vm.permit.permit_end.toJSON().slice(0, 10);
          }
          if(vm.permit.permit_type=="6"){
            delete(permit.customer)
          } else if(!vm.permit.customer_type){
            vm.permit.customer_type = "1"
          }
          permitServices.savePermit(permit).then(function (data) {
            $log.debug(data);
            $window.history.back()
          }, function (err) {
            $log.debug(err);
            alert("Virhe, ei voitu tallentaa asukaslupaa");
            //$log.debug(data);
          });
        };

        vm.nameSelected = function ($item, $model, $label) {
          permitServices.getCustomer($model.id).then(function (data) {
              $log.debug("dada", vm.permit);
              vm.permit.customer = data;
              $log.debug("dada", data);
            },
            function (data) {
              $log.debug("error:: ", data);
            });

          $log.debug("nameselecter", $item, $model, $label);

        };

        vm.clear_customer = function () {
          var ctype = vm.permit.customer.customer_type;
          var ptype = vm.permit.permit_type
          vm.permit.customer = {};
          vm.permit.customer.customer_type = ctype;
          vm.permit.permit_type = ptype;
        };

        vm.getName = function (val, datafield) {
          if (!vm.permit.customer)return;
          if(vm.limitedUser) return; // limited users are not allowed to have name autocomplete -> GDPR etc good reasons

          $log.debug(val);
          var props = [];
          var fields = ['firstname', 'lastname', 'companyname', 'customer_id'];

          for (var f in fields) {
            if (vm.permit.customer &&vm.permit.customer[f]) {
              if (vm.permit.customer[f].length === 0) {
                props[f] = undefined;

              }else {
              props[f]=vm.permit.customer[f]}
            }

            }
            props[datafield]=val;

          return permitServices.getCustomerProposals(props['firstname'], props['lastname'], props['companyname'], props['vm.permit.customer.registration_id']).then(
            function (data) {
              var r = data.results;
              for (var index = 0, len = r.length; index < len; ++index) {
                var line = {};
                angular.forEach(r[index], function (value, key) {
                  line[key] = value != null ? value : "";
                });
                props.push(line)
              }
              return props
            },
            function (data) {
              $log.debug("errr", data);
            }
          )

        };

        vm.today = function () {
          vm.dt = new Date();
        };
        vm.today();

        vm.clear = function () {
          vm.dt = null;
        };
        vm.dateOptions = {
          formatYear: 'yy',
          startingDay: 1
        };
        vm.open1 = function () {
          vm.popup1.opened = true;
        };

        vm.open2 = function () {
          vm.popup2.opened = true;
        };

        vm.format = "dd.MM.yyyy";

        vm.popup1 = {
          opened: false
        };

        vm.popup2 = {
          opened: false
        }

        vm.customerTypeChanged = function () {
          $log.debug('customerTypeChanged, customer_type:', vm.permit.customer.customer_type);
          if(vm.permit.permit_type === '10') {  // kunnossapito
            $log.debug('   customer_type ---> 2');
            vm.permit.customer.customer_type = '2';  // yritys
          }
        }

        vm.getLastDayOfYear = function () {
          var now = moment();  // current date and time
          now.set({'month': 11, 'date': 31});  // december 31
          return new Date(now);
        };
        var getdaysahead = function(nrodays, date){
          return new Date(date.getFullYear(), date.getMonth(), date.getDate()+nrodays);
        }

        function getFilteredParkingAreas(parkingAreas, permitType) {
          var response = [];
          if(!parkingAreas) {
            $log.warn('getFilteredParkingAreas, parkingAreas:', parkingAreas);
            $log.debug('getFilteredParkingAreas, response:', response);
            return response;
          }
          if(!permitType) {
            $log.warn('getFilteredParkingAreas, permitType:', permitType);
            $log.debug('getFilteredParkingAreas, response:', response);
            return response;
          }
          angular.forEach(parkingAreas, function (parkingArea) {
            var relatedPermits = parkingArea.related_permits.split(',');
            angular.forEach(relatedPermits, function (relatedPermit) {
              if(relatedPermit === permitType) {
                response.push(parkingArea);
              }
            })
          })
          $log.debug('getFilteredParkingAreas, response:', response);
          return response;
        }

      }]);

})();


(function() {
  'use strict';

  angular
    .module('office')
    .controller('PaidParkingController', ['$timeout', function ($timeout) {
    var vm = this;

    vm.awesomeThings = [];
    vm.classAnimation = '';
    vm.creationDate = 1466608974937;


    activate();

    function activate() {
      $timeout(function() {
        vm.classAnimation = 'rubberBand';
      }, 4000);
    }

  }]);

})();

(function () {
  'use strict';

  angular
    .module('office')
    .run(['$rootScope', '$state', 'AuthService', 'AUTH_EVENTS', '$log', function ($rootScope, $state, AuthService, $log) {
      $rootScope.deletechangestart = $rootScope.$on("$stateChangeStart", function (event, toState, toParams) {
        $log.info(toParams);
        if (toState.authenticate && !AuthService.isAuthenticated()) {
          // User isn’t authenticated
          $state.transitionTo("login");
          event.preventDefault();
        }
      });
    }]);
})();

(function () {
  'use strict';

  angular
    .module('office')
    .config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
      $stateProvider
        .state('home', {
          url: '/',
          templateUrl: 'app/main/main.html',
          controller: 'MainController',
          controllerAs: 'main',
          authenticate: true
        })
        .state('paidparking', {
          url: '/paidparking',
          templateUrl: 'app/paidparking/paidparking.html',
          controller: 'PaidParkingController',
          controllerAs: 'paid',
          authenticate: true

        }).state("login", {
        url: "/login",
        templateUrl: "app/login/login.html",
        controller: "LoginController",
        controllerAs: 'login',
        authenticate: false
      }).state("permitparking", {
        abstract: true,
        url: "/permitparking",
        templateUrl: "app/permits/permits.html",
        authenticate: true
      }).state("permitparking.permiteditor", {
        url: "/permiteditor",
        templateUrl: "app/permits/permiteditor.html",
        controller: "PermitEditorController",
        params: {
          permitID:null,
          contract_number:null
        },
        controllerAs: 'pe',
        authenticate: true
      }).state("permitparking.permitlist", {
        url: "",
        templateUrl: "app/permits/permitslist.html",
        controller: "PermitsListController",
        controllerAs: 'pl',
        authenticate: true
      });

      $urlRouterProvider.otherwise('/');


    }]);


})();

(function () {
  'use strict';

  angular
    .module('office')
    .constant('AUTH_EVENTS', {
      loginSuccess: 'auth-login-success',
      loginFailed: 'auth-login-failed',
      logoutSuccess: 'auth-logout-success',
      sessionTimeout: 'auth-session-timeout',
      notAuthenticated: 'auth-not-authenticated',
      notAuthorized: 'auth-not-authorized'
    })
    .constant('USER_ROLES', {
    all: '*',
    admin: 'admin',
    editor: 'editor',
    guest: 'guest'
  })

})();

(function() {
  'use strict';

  angular
    .module('office')
    .config(['$logProvider','$httpProvider', function($logProvider,$httpProvider) {
      $httpProvider.defaults.headers.common["X-Requested-With"] = 'XMLHttpRequest';
      $logProvider.debugEnabled(true);
      $httpProvider.defaults.xsrfCookieName = 'csrftoken';
      $httpProvider.defaults.xsrfHeaderName = 'X-CSRFToken';

  }
]);


})();

angular.module("office").run(["$templateCache", function($templateCache) {$templateCache.put("app/login/login.html","<div login-dialog></div>");
$templateCache.put("app/main/main.html","<div class=container><div class=row><div class=col-md-6 ng-if=!main.limitedUser><h3>Pysäköintitietojen haku</h3><p>Syötä alla oleviin kenttiin ajoneuvon rekisteritunnus, päivämäärä ja kellon aika, milloin ajoneuvon pysäköintioikeuksista halutaan tietää</p><form class=form name=rightsqueryform><label class=align-right>Rekisteritunnus <input ng-disabled=main.limitedUser type=text class=form-control ng-model=main.regid placeholder=Rekisteritunnus required></label><br><p class=input-group style=\"width: 50%\"><label class=align-right>Päivämäärä:</label><input type=text class=form-control name=main.regdate style=\"width: 100%\" uib-datepicker-popup=\"{{ main.format }}\" ng-model=main.regdate ng-focus=main.opendategive($event) is-open=main.dategiven toggle-weeks-text=viikko datepicker-options=main.dateOptions clear-text=tyhjennä current-text=Tänään close-text=Sulje close-text=sulje required> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=main.opendategive($event) style=margin-top:23px><i class=\"glyphicon glyphicon-calendar\"></i></button> </span></p><p class=input-group style=\"width: 50%\"><label class=align-right>kellonaika<div uib-timepicker ng-model=main.regtime show-meridian=false></div></label></p><button type=button ng-disabled=rightsqueryform.$invalid class=\"btn btn-primary align-right\" ng-click=main.getParking_info()>Hae</button></form><br><table class=\"table table-condensed\"><tr><th>pys.alue</th><th>alkoi</th><th>päättyi</th></tr><tr ng-repeat=\"row in main.regresponse\"><td>{{ row.areaNo }}</td><td>{{ row.startDate|datetimeISOtoFinShort }}</td><td>{{ row.endDate|datetimeISOtoFinShort }}</td></tr></table></div><div class=col-md-6><div class=row><h3>Pysäköintiluvat</h3><div class=row><div class=col-md-12><p>Paina nappia luodaksesi uusi pitkäaikaispysäköintilupa.</p><button type=button class=\"btn btn-primary align-right\" ng-click=main.getNewPermit()>Uusi lupa</button><br></div></div><div class=row ng-if=!main.limitedUser><div class=col-md-5><br><p>Hae lupa sopimusnumerolla</p><label class=align-right>Sopimusnumero <input type=number class=form-control ng-model=main.contract_number placeholder=sopimusnumero></label></div><div class=col-md-3><br><br><br><br><button type=submit class=\"btn btn-primary ui-button\" style=\"vertical-align: bottom\" ng-disabled=false ng-click=main.get_permit_contractnumber()>Hae lupa</button></div></div><div class=row ng-if=!main.limitedUser><h3>Pikaraportit</h3><p><b>Voimassa olevat pysäköintiluvat alueittain</b></p><button type=submit class=\"btn btn-primary ui-button\" style=margin-right:5px ng-disabled=false ng-click=main.activepermits()>Voimassa olevat luvat</button><br><br><p><b>Maksupysäköinnin kk-raportti</b></p><br><div class=col-md-3><label>Kuukausi<select class=form-control ng-model=main.reportmonth><option value=01>tammikuu</option><option value=02>helmikuu</option><option value=03>maaliskuu</option><option value=04>huhtikuu</option><option value=05>toukokuu</option><option value=06>kesäkuu</option><option value=07>heinäkuu</option><option value=08>elokuu</option><option value=09>syyskuu</option><option value=10>lokakuu</option><option value=11>marraskuu</option><option value=12>joulukuu</option></select></label></div><div class=col-md-3><label>Vuosi<select class=form-control ng-model=main.reportyear ng-options=\"year for year in main.reportyearoptions\"></select></label></div><div class=col-md-3><br><button type=submit class=\"btn btn-primary ui-button\" style=margin-right:5px ng-disabled=false ng-click=main.paidparking_all_report()>hae raportti</button></div></div><div class=row><div class=md-col-12 ng-if=!main.limitedUser><br><p><b>Maksupysäköinnin päiväraportti</b></p><br><div class=col-md-4><p class=input-group style=\"width: 50%\"><label class=align-right>Päivämäärä:</label><input type=text class=form-control name=main.dayreportday style=\"width: 100%\" uib-datepicker-popup=\"{{ main.format }}\" ng-model=main.dayreportday ng-focus=main.reportdayopen($event) is-open=main.dayreportopen toggle-weeks-text=viikko datepicker-options=main.dateOptions clear-text=tyhjennä current-text=Tänään close-text=Sulje close-text=sulje required> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=main.reportdayopen($event) style=margin-top:23px><i class=\"glyphicon glyphicon-calendar\"></i></button> </span></p></div><div class=col-md-3><br><button type=submit class=\"btn btn-primary ui-button\" style=margin-right:5px ng-disabled=false ng-click=main.paidparking_day_report()>hae raportti</button></div></div></div></div></div></div></div>");
$templateCache.put("app/paidparking/paidparking.html","<div class=container style=\"height: 100%\"><payment-table style=\"height: 100%\"></payment-table></div>");
$templateCache.put("app/permits/permiteditor.html","<script type=text/ng-template id=customTemplate.html><a>\n    <div>\n      <div style=\"display:block;\" class=\"name_typehead\"><strong>{{ match.model.name }}</strong></div>\n      <div>{{ match.model.streetaddress }}</div>\n      <div> {{ match.model.zipcode }} {{ match.model.city }}</div>\n    </div>\n  </a></script><style>.full button span {\n    background-color: limegreen;\n    border-radius: 32px;\n    color: black;\n  }\n\n  .partially button span {\n    background-color: orange;\n    border-radius: 32px;\n    color: black;\n  }</style><div class=container><div class=row><div class=col-md-12><h3 ng-if=!pe.limitedUser>Pysäköintisopimuksen tiedot (Sopimusnumero {{ pe.permit.contract_number }}) <span class=pull-right>Operaattori: {{ pe.permit.operator }}</span></h3></div></div><form novalidate name=permit class=\"form form-horizontal\" role=form><div class=\"panel panel-default\" ng-show=true><div class=panel-heading><h3 class=\"panel-title clearfix\">Pysäköintiluvan tyyppi <span class=pull-right><button type=submit ng-click=pe.renew_permit() ng-if=!pe.limitedUser class=\"btn btn-primary uibuttons\">kopioi lupa</button></span></h3></div><div class=panel-body><div class=form-group><div class=col-md-5><label for=permit_type>Pysäköintilupatyyppi<select class=form-control name=permit_type ng-model=pe.permit.permit_type ng-change=pe.permitchanged(key.key)><option ng-repeat=\"key in pe.permittypes track by $index\" value=\"{{ key.key }}\">{{ key.value }}</option></select></label></div><div class=\"form-group col-md-6\" ng-show=pe.visible.granted_by><label for=inputGrantedBy>Luvan myöntäjä</label><input type=text class=form-control id=inputGrantedBy name=grantedBy ng-model=pe.permit.granted_by ng-required=pe.mandatory.granted_by><div ng-messages=permit.grantedBy.$error role=alert><p ng-message=required class=bg-danger>Luvan myöntäjä on pakollinen tieto</p></div></div></div></div></div><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>Ajoneuvo / paikka</h3></div><div class=panel-body><div class=form-group><div class=col-md-3><label for=regid>Rekisteritunnus <input name=regid type=text placeholder=REG-123 required class=form-control ng-model=pe.permit.regid></label><p ng-show=permit.regid.$error.required class=bg-danger>Rekisteritunnus on pakollinen tieto</p><label for=regid ng-if=pe.visible.namedparkingplace>Nimetty paikan tunnus<textarea name=namedparkingplace maxlength=59 placeholder=55 rows=3 class=form-control ng-model=pe.permit.parkingplace></textarea></label><label for=parking_area ng-if=pe.visible.parking_area_visible>Valitse p.paikan tyyppi:<select class=\"form-control col-md-11\" name=place_type ng-model=pe.permit.placeType><option ng-repeat=\"item in pe.placeTypes\" value=\"{{ item.key }}\">{{ item.value }}</option></select></label></div><div class=col-md-3><label for=parking_area ng-if=pe.visible.parking_area_visible>Valitse pysäköintialue:</label><select class=\"form-control col-md-11\" name=parking_area ng-model=pe.selected_area ng-if=pe.visible.parking_area_visible ng-change=pe.add_parkingarea(item)><option ng-repeat=\"item in pe.filteredParkingAreas\" value=\"{{ item.parkingareaid }}\">{{ item.name }}</option></select><label for=parking_area_name ng-if=pe.visible.parking_area_visible>Pysäköintialue<table class=\"table table-condensed table-borderless col-md-12\"><tr ng-repeat=\"item in pe.permit.parking_area\"><td class=col-md-11>{{ item.name }}</td><td class=col-md-1><button class=\"btn btn-transparent\" ng-click=pe.removeParkingArea($index)><i class=\"glyphicon glyphicon-trash btn-transparent\"></i></button></td></tr></table></label><p ng-show=permit.parking_area_name_2.$error.required class=bg-danger>Pysäköintialue on pakollinen tieto</p></div><div class=col-md-3><label for=starttime>Voimassaolo alkaa<p class=input-group><input name=starttime type=text class=form-control uib-datepicker-popup=\"{{ pe.format }}\" ng-model=pe.permit.permit_start is-open=pe.popup1.opened datepicker-options=pe.dateOptions close-text=Sulje clear-text=tyhjennä current-text=Tänään ng-change=pe.permit_start_changed()> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=pe.open1()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></label><div class=form-group ng-if=pe.visible.permit_validity_6_12><label>Voimassaoloaika</label><br><label class=radio-inline><input type=radio name=six_or_12 ng-value=6 ng-model=pe.end_extension ng-change=pe.period_changed(6)> 6 kk</label><label class=radio-inline><input type=radio name=six_or_12 ng-value=12 ng-model=pe.end_extension ng-change=pe.period_changed(12)> 12 kk</label><label class=radio-inline><input type=radio name=six_or_12 ng-value=null ng-model=pe.end_extension ng-change=pe.period_changed(-1)> muu</label></div><div ng-if=\"pe.visible.permitvalidity_in_months \" class=\"form-group col-md-10\"><label for=validityinmonths>voimassaolo kk (30pv)<select class=form-control style=width:200px name=permitvalidity_in_months ng-model=pe.permitvalidity_in_months ng-change=pe.period_changed(pe.permitvalidity_in_months)><option value=1>1 kk</option><option value=2>2 kk</option><option value=3>3 kk</option><option value=4>4 kk</option><option value=5>5 kk</option><option value=6>6 kk</option><option value=7>7 kk</option><option value=8>8 kk</option><option value=9>9 kk</option><option value=10>10 kk</option><option value=10>10 kk</option><option value=11>11 kk</option><option value=12>12 kk</option></select></label></div></div><div class=col-md-2><label for=endtime>Päättymisaika<p class=input-group><input name=endtime type=text class=form-control uib-datepicker-popup=\"{{ pe.format }}\" ng-model=pe.permit.permit_end is-open=pe.popup2.opened datepicker-options=pe.dateOptions ng-change=pe.endtime_changed() close-text=Sulje clear-text=tyhjennä current-text=Tänään> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=pe.open2()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><p ng-if=pe.date_error class=alert-danger>Päiväluvan kesto voi olla korkeintaan 14 päivää</p><p></p></label></div></div></div></div><div class=\"panel panel-default\"><div class=panel-heading><h3 class=\"panel-title clearfix\">Luvan haltija <span class=pull-right><button type=submit ng-click=pe.clear_customer() class=\"btn btn-primary uibuttons\">Tyhjennä asiakastiedot</button></span></h3></div><div class=panel-body><div class=col-md-12><p>täytä tiedot alle, mikäli syöttämiäsi tietoja vastaavia asiakkaita on jo tallennettu, niin ne näytetään alle ilmestyvään listaan. Mikäli löydät tietoja vastaavan asiakkaan, niin valitse hänet listasta. Jos haluat vaihtaa lupaan liittyvää asiakasta, niin paina ensin nappia tyhjennä asiakastiedot</p></div><div class=form-group><div class=col-md-2 ng-if=pe.visible.customertype><label ng-required=pe.mandotory.customertype for=customer_type ng-if=pe.visible.customertype>Asiakastyyppi<select class=form-control name=customer_type ng-model=pe.permit.customer.customer_type ng-change=pe.customerTypeChanged()><option value=1>Henkilö</option><option value=2>Yritys</option></select></label></div><div class=col-md-2 ng-if=pe.visible.lastname><label for=firstname>Etunimi <input type=text name=firstname placeholder=Etunimi class=form-control autocomplete=false ng-model=pe.permit.customer.firstname typeahead-on-select=\"pe.nameSelected($item, $model, $label)\" typeahead-focus-first=false uib-typeahead=\"customer as customer.firstname for customer in pe.getName($viewValue, \'firstname\')\" typeahead-loading=loadingLocations typeahead-template-url=customTemplate.html ng-required=\"pe.mandatory_all[pe.permit.permit_type].firstname&&pe.permit.customer.customer_type==\'1\'\"> <i ng-show=loadingLocations class=\"glyphicon glyphicon-refresh\"></i><p ng-show=permit.firstname.$error.required class=bg-danger>Etunimi on pakollinen tieto</p></label></div><div class=col-md-3 ng-if=pe.visible.lastname><label for=lastname>Sukunimi <input type=text name=lastname placeholder=Sukunimi class=form-control name=lastname autocomplete=false ng-model=pe.permit.customer.lastname typeahead-on-select=\"pe.nameSelected($item, $model, $label)\" typeahead-focus-first=false uib-typeahead=\"customer as customer.lastname for customer in pe.getName($viewValue, \'lastname\')\" typeahead-loading=loadingLocations typeahead-template-url=customTemplate.html ng-required=\"pe.mandatory_all[pe.permit.permit_type].lastname&&pe.permit.customer.customer_type==\'1\'\"> <i ng-show=loadingLocations class=\"glyphicon glyphicon-refresh\"></i><p ng-show=permit.lastname.$error.required class=bg-danger>Sukunimi on pakollinen tieto</p></label></div><div class=col-md-2 ng-if=pe.visible.companyname><label for=companyname>Yritys/Yhteisö <input type=text name=companyname placeholder=Yhteisönnimi class=form-control pe.mandatory_all[pe.permit.permit_type].companyname autocomplete=false ng-model=pe.permit.customer.companyname typeahead-on-select=\"pe.nameSelected($item, $model, $label)\" typeahead-focus-first=false uib-typeahead=\"customer as customer.companyname for customer in pe.getName($viewValue, \'companyname\')\" typeahead-loading=loadingLocations typeahead-template-url=customTemplate.html ng-required=\"pe.permit.customer.customer_type==\'2\'&&\'pe.mandatory.companyname\'\"> <i ng-show=loadingLocations class=\"glyphicon glyphicon-refresh\"></i><p ng-show=permit.companyname.$error.required class=bg-danger>Yhteisön nimi on pakollinen tieto</p></label></div><div class=col-md-2 ng-if=pe.visible.registration_id><label for=tunnus>Tunnus <input type=text name=tunnus placeholder=Hetu/y-tunnus class=form-control autocomplete=false ng-model=pe.permit.customer.registration_id typeahead-on-select=\"pe.nameSelected($item, $model, $label)\" typeahead-focus-first=false uib-typeahead=\"customer as customer.registration_id for customer in pe.getName($viewValue, \'registration_id\')\" typeahead-loading=loadingLocations typeahead-template-url=customTemplate.html> <i ng-show=loadingLocations class=\"glyphicon glyphicon-refresh\"></i></label></div></div><div class=form-group><div class=col-md-2 ng-if=pe.visible.streetaddress><label for=streetaddress>Katuosoite <input name=streetaddress type=text placeholder=Katuosoite ng-required=pe.mandatory.streetaddress class=form-control ng-model=pe.permit.customer.streetaddress></label><p ng-show=permit.streetaddress.$error.required class=bg-danger>Katuosoite on pakollinen tieto</p></div><div class=col-md-2><label for=zipcode ng-if=pe.visible.zipcode>Postinumero <input name=zipcode type=text placeholder=Postinumero minlength=5 maxlength=5 ng-required=pe.mandatory.zipcode ng-if=pe.visible.zipcode class=form-control ng-model=pe.permit.customer.zipcode></label><p ng-show=permit.zipcode.$error.required class=bg-danger>Postinumero on pakollinen</p><p ng-show=(permit.zipcode.$error.minlength||permit.zipcode.$error.minlength)&&!permit.zipcode.$error.required class=bg-danger>Postinumerossa on 5 numeroa</p></div><div class=col-md-3 ng-if=pe.visible.city><label for=city>Postitoimipaikka <input name=city type=text placeholder=Postitoimipaikka class=form-control ng-required=pe.mandatory.city ng-model=pe.permit.customer.city></label><p ng-show=permit.city.$error.required class=bg-danger>Postitoimipaikka on pakollinen tieto</p></div><div class=col-md-2 ng-if=pe.visible.telephonenumber><label for=telephonenumber>Puhelinnumero <input name=telephonenumber type=text placeholder=puhelinnumero class=form-control ng-model=pe.permit.customer.telephonenumber ng-required=pe.permit.customer.allow_sms&&pe.mandatory.telephone></label><p ng-show=permit.telephonenumber.$error.required class=bg-danger>Puhelinnumero on pakollinen tieto, jos haluat tiedotteita</p></div><div class=col-md-2 ng-required=pe.mandatory.email ng-if=pe.visible.email><label for=email>Sähköpostiosoite <input name=email type=email placeholder=Sähköpostiosoite class=form-control ng-model=pe.permit.customer.email ng-required=pe.permit.customer.allow_email&&pe.mandatory.email></label><p ng-show=permit.email.$error.email class=bg-danger>sähköpostiosoite ei ole oikeanmuotoinen</p><p ng-show=permit.email.$error.required class=bg-danger>Sähköpostiosoite on pakollinen tieto, jos haluat tiedotteita</p></div><div class=form-group><div class=col-md-12><label for=extrainformation ng-show=pe.visible.extrainformation>Lisätietoja</label><textarea name=extrainformation ng-show=pe.visible.extrainformation rows=3 cols=80 maxlength=500 ng-model=pe.permit.extrainformation></textarea></div></div></div></div><div class=\"panel panel-default\" ng-if=visible.additionalusers><div class=panel-heading><h3 class=panel-title><span class=col-md-6>Luvan muut käyttäjät </span><span class=pull-col-md-6>Ladatut tiedostot</span></h3></div><div class=panel-body><div class=form-group><div class=col-md-2><label class=control-label for=email>Lisäkäyttäjä 1</label><input name=firstextra type=text placeholder=\"Etunimi Sukunimi\" class=form-control ng-model=pe.permit.name_of_additional_user_1></div><div class=col-md-2><label class=control-label for=email>Lisäkäyttäjä 2</label><input name=secondextra type=text placeholder=\"Etunimi Sukunimi\" class=form-control ng-model=pe.permit.name_of_additional_user_2></div><div class=col-md-2></div><div class=col-md-2><label class=\"btn btn-primary btn-file\" ng-disabled=!pe.permit.id>{{ pe.permit.permitID }} Lisää tiedosto <input ngf-select=\"pe.uploadFiles($file, $invalidFiles)\" accept=image/*,application/pdf ng-disabled=!pe.permit.id ngf-max-size=9MB type=file style=\"display: none\"></label></div><div class=col-md-4><table class=\"table table-condensed\"><tr ng-repeat=\"row in pe.permit.permit_file\"><td>{{ row.originalname }}</td><td><button class=\"btn btn-transparent\" ng-click=pe.deleteattachementfile($index)><i class=\"glyphicon glyphicon-trash btn-transparent\"></i></button> <a class=\"btn btn-transparent\" target=_blank ng-href=\"\'/permits/permitfile/\'{{row.id}}\"><i class=\"glyphicon glyphicon-edit\"></i></a></td></tr></table></div></div></div></div><div name=show_billing_address class=\"panel panel-default\" ng-if=pe.visible.show_billing_address><div class=panel-heading><h3 class=panel-title>Laskutusosoite (Jos eri kuin yllä)</h3></div><div class=panel-body><div class=form-group><div class=col-md-3><label for=firstname>Vastaanottajan nimi (Jos tarpeen) <input name=billing_name type=text placeholder=\"Etunimi Sukunimi\" class=form-control ng-model=pe.permit.customer.billing_contact_name></label></div><div class=col-md-3><label for=billing_companyname>Yritys/Yhteisö <input name=billing_companyname type=text placeholder=Yhteisönnimi class=form-control ng-model=pe.permit.customer.billing_company_name></label></div></div><div class=form-group><div class=col-md-2><label for=billing_streetaddress>Katuosoite <input name=billing_streetaddress type=text placeholder=Katuosoite class=form-control ng-model=pe.permit.customer.billing_streetaddress></label></div><div class=col-md-2><label for=zipcode>Postinumero <input name=billing_zipcode type=text placeholder=Postinumero minlength=5 maxlength=5 class=form-control ng-model=pe.permit.customer.billing_zipcode></label></div><div class=col-md-3><label for=billing_city>Postitoimipaikka <input name=billing_city type=text placeholder=Postitoimipaikka class=form-control ng-model=pe.permit.customer.billing_city></label></div></div></div></div><div class=\"panel panel-default\" ng-if=pe.visible.permissionsvisible><div class=panel-heading><h3 class=panel-title>Tieto- ja viestintäluvat <span class=pull-right>Lisätiedot</span></h3></div><div class=panel-body><div class=form-group><div class=col-md-6><b>Haluan tiedotteita muuttuneista pysäköintiolosuhteista, kuten kadunpuhdistuksista:</b><div class=checkbox><label><input name=allow_email type=checkbox ng-model=pe.permit.customer.allow_email>Sähköpostina</label></div><div class=checkbox><label><input name=allow_sms type=checkbox ng-model=pe.permit.customer.allow_sms>tekstiviestinä</label></div></div></div></div></div></div></form><div class=row><span><button type=submit ng-click=pe.remove_permit() class=\"btn btn-danger uibuttons\" ng-if=!pe.limitedUser ng-disabled=permit.$invalid>Poista lupa</button> </span><span class=pull-right><button type=submit ng-click=pe.cancel() class=\"btn btn-default uibuttons\">Peruuta</button> <button type=submit ng-click=pe.save_print() class=\"btn btn-primary uibuttons\" ng-if=!pe.limitedUser ng-disabled=permit.$invalid>Tulosta</button> <button type=submit ng-click=pe.save() class=\"btn btn-primary uibuttons\" ng-disabled=permit.$invalid>Tallenna</button><div style=color:red>{{ pe.cannot_yet_print }}</div></span></div></div>");
$templateCache.put("app/permits/permits.html","<div class=container style=\"height: 100%\"><div ui-view></div></div>");
$templateCache.put("app/permits/permitslist.html","<div class=container style=\"height: 100%\"><div class=row style=\"margin-bottom: 4mm\"><div class=col-md-1><button type=button class=\"btn btn-primary align-right\" ng-click=pl.getNewPermit()>Uusi lupa</button></div></div><div class=row><div class=col-md-12><permit-list-table></permit-list-table></div></div></div>");
$templateCache.put("app/components/gendialog/gendialog.html","<div class=modal-header><h3>{{main.headingtext}}</h3></div><div class=modal-body><p>{{ main.explanation }}</p></div><div class=modal-footer><button type=button class=btn data-ng-click=main.dismiss() ng-show=main.cancelvisible>{{main.closebuttontext}}</button> <button type=submit class=\"btn btn-primary\" ng-show=main.okvisible ng-click=main.agree();>{{main.actionbuttontext}}</button></div>");
$templateCache.put("app/components/logindialog/login-form.html","<div class=container><form class=form-signin id=loginform name=loginform ng-submit=login(cred)><div id=login-form><h1>Kirjaudu sisään</h1><input id=Kayttajatunnus type=text class=form-control placeholder=Käyttäjätunnus ng-model=cred.username> <input id=salasana type=password class=form-control placeholder=Salasana ng-model=cred.password> <button class=\"btn btn-large btn-primary\" type=submit name=commit>Kirjaudu</button></div><div class=alert-danger>{{ message }}</div></form></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\"><div class=container-fluid><div class=navbar-header><a class=navbar-brand href=#><span class=\"glyphicon glyphicon-home\"></span> ParkkiV Luvat&trade;</a></div><div class=\"collapse navbar-collapse\" id=bs-example-navbar-collapse-6><ul class=\"nav navbar-nav\" ng-if=!limitedUser><li ui-sref-active=active><a ui-sref=home>Koti</a></li><li ui-sref-active=active><a ui-sref=paidparking>Maksupysäköinnit</a></li><li ui-sref-active=active><a href=\"\" ui-sref=permitparking.permitlist>Lupapysäköinnit</a></li></ul><ul class=\"nav navbar-nav navbar-right acme-navbar-text\"><li class=active><a href=\"\" ng-click=logout()>Kirjaudu ulos</a></li></ul></div></div></nav>");
$templateCache.put("app/components/paidparkings/paidparkingtable.html","<div style=height:100%><div id=grid1 ui-grid-pagination ui-grid=$ctrl.gridOptions class=grid style=\"height: 800px\"></div></div><script type=text/ng-template id=custom-date-filter.html><div class=\"modal-content col-md-12 col-md-offset-0 col-sm-12 col-sm-offset-0 col-xs-12 col-xs-offset-0\">\n\n        <div class=\"modal-header\">\n          <p class=\"modal-title well custom-date-filter-header\">\n            <span class=\"custom-date-filter-title-text\">\n              {{ custom.title }}\n            </span>\n          </p>\n        </div>\n\n        <div class=\"row modal-body custom-date-filter-container-row\">\n\n          <form name=\"custom.customDateFilterForm\"\n                ng-submit=\"custom.setFilterDate(custom.filterDate)\"\n                no-validation>\n\n            <div class=\"row custom-filter-date-input-row\">\n\n              <div class=\"well col-md-8 col-md-offset-2 col-sm-8 col-sm-offset-2 col-xs-10 col-xs-offset-1 custom-date-filter-input\">\n\n                <uib-datepicker ng-model=\"custom.filterDate\"\n                    min-date=\"custom.minDate\"\n                    max-date=\"custom.maxDate\"\n                    ng-change=\"custom.filterDateChanged()\"\n                    class=\"well well-sm\">\n                </uib-datepicker>\n\n              </div>\n\n            </div>\n\n            <div class=\"row modal-footer custom-date-filter-submit-buttons-row\">\n\n              <div class=\"custom-date-filter-submit-buttons-div col-lg-8 col-lg-offset-2 col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1 col-xs-10 col-xs-offset-1\">\n\n                <button class=\"btn btn-success btn-lg custom-date-filter-submit-button\"\n                        type=\"submit\">\n                  Apply\n                </button>\n\n                <button type=\"button\"\n                        class=\"btn btn-warning btn-lg custom-date-filter-cancel-button\"\n                        ng-click=\"custom.cancelDateFilter()\">\n                  Cancel\n                </button>\n\n              </div>\n\n            </div>\n\n          </form>\n\n        </div>\n\n      </div></script>");
$templateCache.put("app/components/permiteditor/permiteditor.html","<div style=height:100%><form novalidate name=permit class=form-horizontal><div class=form-group><div class=col-md-1><label for=firstname>Etunimi<input name=firstname type=text placeholder=Etunimi ng-model=customer.firstname></label><label for=lastname>Sukunimi<input type=text name=lastname placeholder=Etunimi ng-model=customer.firstname></label></div><div class=col-md-3></div></div></form></div>");
$templateCache.put("app/components/permitlist/permitlistable.html","<div style=height:100%><div class=row><div class=col-md3><label>Näytä vanhentuneet luvat <input type=checkbox ng-model=$ctrl.include_expired ng-change=$ctrl.expiredChanged()></label></div></div><div id=grid1 ui-grid-pagination ui-grid-selection ui-grid=$ctrl.gridOptions class=grid style=\"height: 800px\"></div></div><script type=text/ng-template id=custom-date-filter.html><div class=\"modal-content col-md-12 col-md-offset-0 col-sm-12 col-sm-offset-0 col-xs-12 col-xs-offset-0\">\n\n        <div class=\"modal-header\">\n          <p class=\"modal-title well custom-date-filter-header\">\n            <span class=\"custom-date-filter-title-text\">\n              {{ custom.title }}\n            </span>\n          </p>\n        </div>\n\n        <div class=\"row modal-body custom-date-filter-container-row\">\n\n          <form name=\"custom.customDateFilterForm\"\n                ng-submit=\"custom.setFilterDate(custom.filterDate)\"\n                no-validation>\n\n            <div class=\"row custom-filter-date-input-row\">\n\n              <div class=\"well col-md-8 col-md-offset-2 col-sm-8 col-sm-offset-2 col-xs-10 col-xs-offset-1 custom-date-filter-input\">\n\n                <uib-datepicker ng-model=\"custom.filterDate\"\n                    min-date=\"custom.minDate\"\n                    max-date=\"custom.maxDate\"\n                    ng-change=\"custom.filterDateChanged()\"\n                    class=\"well well-sm\">\n                </uib-datepicker>\n\n              </div>\n\n            </div>\n\n            <div class=\"row modal-footer custom-date-filter-submit-buttons-row\">\n\n              <div class=\"custom-date-filter-submit-buttons-div col-lg-8 col-lg-offset-2 col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1 col-xs-10 col-xs-offset-1\">\n\n                <button class=\"btn btn-success btn-lg custom-date-filter-submit-button\"\n                        type=\"submit\">\n                  Apply\n                </button>\n\n                <button type=\"button\"\n                        class=\"btn btn-warning btn-lg custom-date-filter-cancel-button\"\n                        ng-click=\"custom.cancelDateFilter()\">\n                  Cancel\n                </button>\n\n              </div>\n\n            </div>\n\n          </form>\n\n        </div>\n\n      </div></script>");}]);